const THREE = require("three");
var vO240 = {};
function f1331(p11064) {
  return URL.createObjectURL(new Blob([p11064], {
    type: "text/javascript"
  }));
}
function f1332(p11065) {
  return new Worker(p11065);
}
try {
  URL.revokeObjectURL(f1331(""));
} catch (e75) {
  f1331 = function (p11066) {
    return "data:application/javascript;charset=UTF-8," + encodeURI(p11066);
  };
  f1332 = function (p11067) {
    return new Worker(p11067, {
      type: "module"
    });
  };
}
function f1333(p11068, p11069, p11070, p11071, p11072) {
  var vF1332 = f1332(vO240[p11069] ||= f1331(p11068));
  vF1332.onerror = function (p11073) {
    return p11072(p11073.error, null);
  };
  vF1332.onmessage = function (p11074) {
    return p11072(null, p11074.data);
  };
  vF1332.postMessage(p11070, p11071);
  return vF1332;
}
var vUint8Array = Uint8Array;
var vUint16Array = Uint16Array;
var vUint32Array = Uint32Array;
var v8131 = new vUint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]);
var v8132 = new vUint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]);
var v8133 = new vUint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
function f1334(p11075, p11076) {
  var v8134 = new vUint16Array(31);
  for (var vLN1116 = 0; vLN1116 < 31; ++vLN1116) {
    v8134[vLN1116] = p11076 += 1 << p11075[vLN1116 - 1];
  }
  var v8135 = new vUint32Array(v8134[30]);
  for (var vLN1116 = 1; vLN1116 < 30; ++vLN1116) {
    for (var v8136 = v8134[vLN1116]; v8136 < v8134[vLN1116 + 1]; ++v8136) {
      v8135[v8136] = v8136 - v8134[vLN1116] << 5 | vLN1116;
    }
  }
  return [v8134, v8135];
}
var vF1334 = f1334(v8131, 2);
var v8137 = vF1334[0];
var v8138 = vF1334[1];
v8137[28] = 258;
v8138[258] = 28;
var vF13342 = f1334(v8132, 0);
var v8139 = vF13342[0];
var v8140 = vF13342[1];
var v8141 = new vUint16Array(32768);
for (var vLN01320 = 0; vLN01320 < 32768; ++vLN01320) {
  var v8142 = (vLN01320 & 43690) >>> 1 | (vLN01320 & 21845) << 1;
  v8142 = (v8142 & 52428) >>> 2 | (v8142 & 13107) << 2;
  v8142 = (v8142 & 61680) >>> 4 | (v8142 & 3855) << 4;
  v8141[vLN01320] = ((v8142 & 65280) >>> 8 | (v8142 & 255) << 8) >>> 1;
}
function f1335(p11077, p11078, p11079) {
  var v8143 = p11077.length;
  var vLN01318 = 0;
  var v8144 = new vUint16Array(p11078);
  for (; vLN01318 < v8143; ++vLN01318) {
    ++v8144[p11077[vLN01318] - 1];
  }
  var v8145 = new vUint16Array(p11078);
  for (vLN01318 = 0; vLN01318 < p11078; ++vLN01318) {
    v8145[vLN01318] = v8145[vLN01318 - 1] + v8144[vLN01318 - 1] << 1;
  }
  var v8146;
  if (p11079) {
    v8146 = new vUint16Array(1 << p11078);
    var v8147 = 15 - p11078;
    for (vLN01318 = 0; vLN01318 < v8143; ++vLN01318) {
      if (p11077[vLN01318]) {
        var v8148 = vLN01318 << 4 | p11077[vLN01318];
        var v8149 = p11078 - p11077[vLN01318];
        var v8150 = v8145[p11077[vLN01318] - 1]++ << v8149;
        for (var v8151 = v8150 | (1 << v8149) - 1; v8150 <= v8151; ++v8150) {
          v8146[v8141[v8150] >>> v8147] = v8148;
        }
      }
    }
  } else {
    v8146 = new vUint16Array(v8143);
    for (vLN01318 = 0; vLN01318 < v8143; ++vLN01318) {
      if (p11077[vLN01318]) {
        v8146[vLN01318] = v8141[v8145[p11077[vLN01318] - 1]++] >>> 15 - p11077[vLN01318];
      }
    }
  }
  return v8146;
}
var v8152 = new vUint8Array(288);
for (var vLN01320 = 0; vLN01320 < 144; ++vLN01320) {
  v8152[vLN01320] = 8;
}
for (var vLN01320 = 144; vLN01320 < 256; ++vLN01320) {
  v8152[vLN01320] = 9;
}
for (var vLN01320 = 256; vLN01320 < 280; ++vLN01320) {
  v8152[vLN01320] = 7;
}
for (var vLN01320 = 280; vLN01320 < 288; ++vLN01320) {
  v8152[vLN01320] = 8;
}
var v8153 = new vUint8Array(32);
for (var vLN01320 = 0; vLN01320 < 32; ++vLN01320) {
  v8153[vLN01320] = 5;
}
var vF1335 = f1335(v8152, 9, 0);
var vF13352 = f1335(v8152, 9, 1);
var vF13353 = f1335(v8153, 5, 0);
var vF13354 = f1335(v8153, 5, 1);
function f1336(p11080) {
  var v8154 = p11080[0];
  for (var vLN1117 = 1; vLN1117 < p11080.length; ++vLN1117) {
    if (p11080[vLN1117] > v8154) {
      v8154 = p11080[vLN1117];
    }
  }
  return v8154;
}
function f1337(p11081, p11082, p11083) {
  var v8155 = p11082 / 8 | 0;
  return (p11081[v8155] | p11081[v8155 + 1] << 8) >> (p11082 & 7) & p11083;
}
function f1338(p11084, p11085) {
  var v8156 = p11085 / 8 | 0;
  return (p11084[v8156] | p11084[v8156 + 1] << 8 | p11084[v8156 + 2] << 16) >> (p11085 & 7);
}
function f1339(p11086) {
  return (p11086 / 8 | 0) + (p11086 & 7 && 1);
}
function f1340(p11087, p11088, p11089) {
  if (p11088 == null || p11088 < 0) {
    p11088 = 0;
  }
  if (p11089 == null || p11089 > p11087.length) {
    p11089 = p11087.length;
  }
  var v8157 = new (p11087 instanceof vUint16Array ? vUint16Array : p11087 instanceof vUint32Array ? vUint32Array : vUint8Array)(p11089 - p11088);
  v8157.set(p11087.subarray(p11088, p11089));
  return v8157;
}
function f1341(p11090, p11091, p11092) {
  var v8158 = p11090.length;
  if (!v8158 || p11092 && !p11092.l && v8158 < 5) {
    return p11091 || new vUint8Array(0);
  }
  var v8159 = !p11091 || p11092;
  var v8160 = !p11092 || p11092.i;
  if (!p11092) {
    p11092 = {};
  }
  if (!p11091) {
    p11091 = new vUint8Array(v8158 * 3);
  }
  function f1342(p11093) {
    var v8161 = p11091.length;
    if (p11093 > v8161) {
      var v8162 = new vUint8Array(Math.max(v8161 * 2, p11093));
      v8162.set(p11091);
      p11091 = v8162;
    }
  }
  var v8163 = p11092.f || 0;
  var v8164 = p11092.p || 0;
  var v8165 = p11092.b || 0;
  var v8166 = p11092.l;
  var v8167 = p11092.d;
  var v8168 = p11092.m;
  var v8169 = p11092.n;
  var v8170 = v8158 * 8;
  do {
    if (!v8166) {
      p11092.f = v8163 = f1337(p11090, v8164, 1);
      var vF1337 = f1337(p11090, v8164 + 1, 3);
      v8164 += 3;
      if (!vF1337) {
        var v8181 = f1339(v8164) + 4;
        var v8172 = p11090[v8181 - 4] | p11090[v8181 - 3] << 8;
        var v8173 = v8181 + v8172;
        if (v8173 > v8158) {
          if (v8160) {
            throw "unexpected EOF";
          }
          break;
        }
        if (v8159) {
          f1342(v8165 + v8172);
        }
        p11091.set(p11090.subarray(v8181, v8173), v8165);
        p11092.b = v8165 += v8172;
        p11092.p = v8164 = v8173 * 8;
        continue;
      } else if (vF1337 == 1) {
        v8166 = vF13352;
        v8167 = vF13354;
        v8168 = 9;
        v8169 = 5;
      } else if (vF1337 == 2) {
        var v8174 = f1337(p11090, v8164, 31) + 257;
        var v8175 = f1337(p11090, v8164 + 10, 15) + 4;
        var v8176 = v8174 + f1337(p11090, v8164 + 5, 31) + 1;
        v8164 += 14;
        var v8177 = new vUint8Array(v8176);
        var v8178 = new vUint8Array(19);
        for (var v8189 = 0; v8189 < v8175; ++v8189) {
          v8178[v8133[v8189]] = f1337(p11090, v8164 + v8189 * 3, 7);
        }
        v8164 += v8175 * 3;
        var vF1336 = f1336(v8178);
        var v8179 = (1 << vF1336) - 1;
        var vF13355 = f1335(v8178, vF1336, 1);
        for (var v8189 = 0; v8189 < v8176;) {
          var v8180 = vF13355[f1337(p11090, v8164, v8179)];
          v8164 += v8180 & 15;
          var v8181 = v8180 >>> 4;
          if (v8181 < 16) {
            v8177[v8189++] = v8181;
          } else {
            var v8186 = 0;
            var vLN01324 = 0;
            if (v8181 == 16) {
              vLN01324 = 3 + f1337(p11090, v8164, 3);
              v8164 += 2;
              v8186 = v8177[v8189 - 1];
            } else if (v8181 == 17) {
              vLN01324 = 3 + f1337(p11090, v8164, 7);
              v8164 += 3;
            } else if (v8181 == 18) {
              vLN01324 = 11 + f1337(p11090, v8164, 127);
              v8164 += 7;
            }
            while (vLN01324--) {
              v8177[v8189++] = v8186;
            }
          }
        }
        var v8182 = v8177.subarray(0, v8174);
        var v8193 = v8177.subarray(v8174);
        v8168 = f1336(v8182);
        v8169 = f1336(v8193);
        v8166 = f1335(v8182, v8168, 1);
        v8167 = f1335(v8193, v8169, 1);
      } else {
        throw "invalid block type";
      }
      if (v8164 > v8170) {
        if (v8160) {
          throw "unexpected EOF";
        }
        break;
      }
    }
    if (v8159) {
      f1342(v8165 + 131072);
    }
    var v8184 = (1 << v8168) - 1;
    var v8185 = (1 << v8169) - 1;
    var vV8164 = v8164;
    for (;; vV8164 = v8164) {
      var v8186 = v8166[f1338(p11090, v8164) & v8184];
      var v8187 = v8186 >>> 4;
      v8164 += v8186 & 15;
      if (v8164 > v8170) {
        if (v8160) {
          throw "unexpected EOF";
        }
        break;
      }
      if (!v8186) {
        throw "invalid length/literal";
      }
      if (v8187 < 256) {
        p11091[v8165++] = v8187;
      } else if (v8187 == 256) {
        vV8164 = v8164;
        v8166 = null;
        break;
      } else {
        var v8188 = v8187 - 254;
        if (v8187 > 264) {
          var v8189 = v8187 - 257;
          var v8194 = v8131[v8189];
          v8188 = f1337(p11090, v8164, (1 << v8194) - 1) + v8137[v8189];
          v8164 += v8194;
        }
        var v8191 = v8167[f1338(p11090, v8164) & v8185];
        var v8192 = v8191 >>> 4;
        if (!v8191) {
          throw "invalid distance";
        }
        v8164 += v8191 & 15;
        var v8193 = v8139[v8192];
        if (v8192 > 3) {
          var v8194 = v8132[v8192];
          v8193 += f1338(p11090, v8164) & (1 << v8194) - 1;
          v8164 += v8194;
        }
        if (v8164 > v8170) {
          if (v8160) {
            throw "unexpected EOF";
          }
          break;
        }
        if (v8159) {
          f1342(v8165 + 131072);
        }
        var v8195 = v8165 + v8188;
        for (; v8165 < v8195; v8165 += 4) {
          p11091[v8165] = p11091[v8165 - v8193];
          p11091[v8165 + 1] = p11091[v8165 + 1 - v8193];
          p11091[v8165 + 2] = p11091[v8165 + 2 - v8193];
          p11091[v8165 + 3] = p11091[v8165 + 3 - v8193];
        }
        v8165 = v8195;
      }
    }
    p11092.l = v8166;
    p11092.p = vV8164;
    p11092.b = v8165;
    if (v8166) {
      v8163 = 1;
      p11092.m = v8168;
      p11092.d = v8167;
      p11092.n = v8169;
    }
  } while (!v8163);
  if (v8165 == p11091.length) {
    return p11091;
  } else {
    return f1340(p11091, 0, v8165);
  }
}
function f1343(p11094, p11095, p11096) {
  p11096 <<= p11095 & 7;
  var v8196 = p11095 / 8 | 0;
  p11094[v8196] |= p11096;
  p11094[v8196 + 1] |= p11096 >>> 8;
}
function f1344(p11097, p11098, p11099) {
  p11099 <<= p11098 & 7;
  var v8197 = p11098 / 8 | 0;
  p11097[v8197] |= p11099;
  p11097[v8197 + 1] |= p11099 >>> 8;
  p11097[v8197 + 2] |= p11099 >>> 16;
}
function f1345(p11100, p11101) {
  var vA415 = [];
  for (var vLN01327 = 0; vLN01327 < p11100.length; ++vLN01327) {
    if (p11100[vLN01327]) {
      vA415.push({
        s: vLN01327,
        f: p11100[vLN01327]
      });
    }
  }
  var v8198 = vA415.length;
  var v8199 = vA415.slice();
  if (!v8198) {
    return [v8237, 0];
  }
  if (v8198 == 1) {
    var v8200 = new vUint8Array(vA415[0].s + 1);
    v8200[vA415[0].s] = 1;
    return [v8200, 1];
  }
  vA415.sort(function (p11102, p11103) {
    return p11102.f - p11103.f;
  });
  vA415.push({
    s: -1,
    f: 25001
  });
  var v8201 = vA415[0];
  var v8202 = vA415[1];
  var vLN01326 = 0;
  var vLN1118 = 1;
  var vLN218 = 2;
  vA415[0] = {
    s: -1,
    f: v8201.f + v8202.f,
    l: v8201,
    r: v8202
  };
  while (vLN1118 != v8198 - 1) {
    v8201 = vA415[vA415[vLN01326].f < vA415[vLN218].f ? vLN01326++ : vLN218++];
    v8202 = vA415[vLN01326 != vLN1118 && vA415[vLN01326].f < vA415[vLN218].f ? vLN01326++ : vLN218++];
    vA415[vLN1118++] = {
      s: -1,
      f: v8201.f + v8202.f,
      l: v8201,
      r: v8202
    };
  }
  var v8203 = v8199[0].s;
  for (var vLN01327 = 1; vLN01327 < v8198; ++vLN01327) {
    if (v8199[vLN01327].s > v8203) {
      v8203 = v8199[vLN01327].s;
    }
  }
  var v8204 = new vUint16Array(v8203 + 1);
  var vIi32 = f1346(vA415[vLN1118 - 1], v8204, 0);
  if (vIi32 > p11101) {
    var vLN01327 = 0;
    var vLN01328 = 0;
    var v8205 = vIi32 - p11101;
    var v8206 = 1 << v8205;
    v8199.sort(function (p11104, p11105) {
      return v8204[p11105.s] - v8204[p11104.s] || p11104.f - p11105.f;
    });
    for (; vLN01327 < v8198; ++vLN01327) {
      var v8207 = v8199[vLN01327].s;
      if (v8204[v8207] > p11101) {
        vLN01328 += v8206 - (1 << vIi32 - v8204[v8207]);
        v8204[v8207] = p11101;
      } else {
        break;
      }
    }
    vLN01328 >>>= v8205;
    while (vLN01328 > 0) {
      var v8208 = v8199[vLN01327].s;
      if (v8204[v8208] < p11101) {
        vLN01328 -= 1 << p11101 - v8204[v8208]++ - 1;
      } else {
        ++vLN01327;
      }
    }
    for (; vLN01327 >= 0 && vLN01328; --vLN01327) {
      var v8209 = v8199[vLN01327].s;
      if (v8204[v8209] == p11101) {
        --v8204[v8209];
        ++vLN01328;
      }
    }
    vIi32 = p11101;
  }
  return [new vUint8Array(v8204), vIi32];
}
function f1346(p11106, p11107, p11108) {
  if (p11106.s == -1) {
    return Math.max(f1346(p11106.l, p11107, p11108 + 1), f1346(p11106.r, p11107, p11108 + 1));
  } else {
    return p11107[p11106.s] = p11108;
  }
}
function f1347(p11109) {
  var v8210 = p11109.length;
  while (v8210 && !p11109[--v8210]) {
    ;
  }
  var v8211 = new vUint16Array(++v8210);
  var vLN01329 = 0;
  var v8212 = p11109[0];
  var vLN1120 = 1;
  function f1348(p11110) {
    v8211[vLN01329++] = p11110;
  }
  for (var vLN1121 = 1; vLN1121 <= v8210; ++vLN1121) {
    if (p11109[vLN1121] == v8212 && vLN1121 != v8210) {
      ++vLN1120;
    } else {
      if (!v8212 && vLN1120 > 2) {
        for (; vLN1120 > 138; vLN1120 -= 138) {
          f1348(32754);
        }
        if (vLN1120 > 2) {
          f1348(vLN1120 > 10 ? vLN1120 - 11 << 5 | 28690 : vLN1120 - 3 << 5 | 12305);
          vLN1120 = 0;
        }
      } else if (vLN1120 > 3) {
        f1348(v8212);
        --vLN1120;
        for (; vLN1120 > 6; vLN1120 -= 6) {
          f1348(8304);
        }
        if (vLN1120 > 2) {
          f1348(vLN1120 - 3 << 5 | 8208);
          vLN1120 = 0;
        }
      }
      while (vLN1120--) {
        f1348(v8212);
      }
      vLN1120 = 1;
      v8212 = p11109[vLN1121];
    }
  }
  return [v8211.subarray(0, vLN01329), v8210];
}
function f1349(p11111, p11112) {
  var vLN01330 = 0;
  for (var vLN01331 = 0; vLN01331 < p11112.length; ++vLN01331) {
    vLN01330 += p11111[vLN01331] * p11112[vLN01331];
  }
  return vLN01330;
}
function f1350(p11113, p11114, p11115) {
  var v8213 = p11115.length;
  var vF1339 = f1339(p11114 + 2);
  p11113[vF1339] = v8213 & 255;
  p11113[vF1339 + 1] = v8213 >>> 8;
  p11113[vF1339 + 2] = p11113[vF1339] ^ 255;
  p11113[vF1339 + 3] = p11113[vF1339 + 1] ^ 255;
  for (var vLN01332 = 0; vLN01332 < v8213; ++vLN01332) {
    p11113[vF1339 + vLN01332 + 4] = p11115[vLN01332];
  }
  return (vF1339 + 4 + v8213) * 8;
}
function f1351(p11116, p11117, p11118, p11119, p11120, p11121, p11122, p11123, p11124, p11125, p11126) {
  f1343(p11117, p11126++, p11118);
  ++p11120[256];
  var vF1345 = f1345(p11120, 15);
  var v8214 = vF1345[0];
  var v8215 = vF1345[1];
  var vF13452 = f1345(p11121, 15);
  var v8216 = vF13452[0];
  var v8217 = vF13452[1];
  var vF1347 = f1347(v8214);
  var v8218 = vF1347[0];
  var v8219 = vF1347[1];
  var vF13472 = f1347(v8216);
  var v8220 = vF13472[0];
  var v8221 = vF13472[1];
  var v8222 = new vUint16Array(19);
  for (var vLN01338 = 0; vLN01338 < v8218.length; ++vLN01338) {
    v8222[v8218[vLN01338] & 31]++;
  }
  for (var vLN01338 = 0; vLN01338 < v8220.length; ++vLN01338) {
    v8222[v8220[vLN01338] & 31]++;
  }
  var vF13453 = f1345(v8222, 7);
  var v8223 = vF13453[0];
  var v8224 = vF13453[1];
  var vLN1910 = 19;
  for (; vLN1910 > 4 && !v8223[v8133[vLN1910 - 1]]; --vLN1910) {
    ;
  }
  var v8225 = p11125 + 5 << 3;
  var v8226 = f1349(p11120, v8152) + f1349(p11121, v8153) + p11122;
  var v8227 = f1349(p11120, v8214) + f1349(p11121, v8216) + p11122 + 14 + vLN1910 * 3 + f1349(v8222, v8223) + (v8222[16] * 2 + v8222[17] * 3 + v8222[18] * 7);
  if (v8225 <= v8226 && v8225 <= v8227) {
    return f1350(p11117, p11126, p11116.subarray(p11124, p11124 + p11125));
  }
  var v8228;
  var v8229;
  var v8230;
  var v8231;
  f1343(p11117, p11126, 1 + (v8227 < v8226));
  p11126 += 2;
  if (v8227 < v8226) {
    v8228 = f1335(v8214, v8215, 0);
    v8229 = v8214;
    v8230 = f1335(v8216, v8217, 0);
    v8231 = v8216;
    var vF13356 = f1335(v8223, v8224, 0);
    f1343(p11117, p11126, v8219 - 257);
    f1343(p11117, p11126 + 5, v8221 - 1);
    f1343(p11117, p11126 + 10, vLN1910 - 4);
    p11126 += 14;
    for (var vLN01338 = 0; vLN01338 < vLN1910; ++vLN01338) {
      f1343(p11117, p11126 + vLN01338 * 3, v8223[v8133[vLN01338]]);
    }
    p11126 += vLN1910 * 3;
    var vA416 = [v8218, v8220];
    for (var vLN01336 = 0; vLN01336 < 2; ++vLN01336) {
      var v8232 = vA416[vLN01336];
      for (var vLN01338 = 0; vLN01338 < v8232.length; ++vLN01338) {
        var v8234 = v8232[vLN01338] & 31;
        f1343(p11117, p11126, vF13356[v8234]);
        p11126 += v8223[v8234];
        if (v8234 > 15) {
          f1343(p11117, p11126, v8232[vLN01338] >>> 5 & 127);
          p11126 += v8232[vLN01338] >>> 12;
        }
      }
    }
  } else {
    v8228 = vF1335;
    v8229 = v8152;
    v8230 = vF13353;
    v8231 = v8153;
  }
  for (var vLN01338 = 0; vLN01338 < p11123; ++vLN01338) {
    if (p11119[vLN01338] > 255) {
      var v8234 = p11119[vLN01338] >>> 18 & 31;
      f1344(p11117, p11126, v8228[v8234 + 257]);
      p11126 += v8229[v8234 + 257];
      if (v8234 > 7) {
        f1343(p11117, p11126, p11119[vLN01338] >>> 23 & 31);
        p11126 += v8131[v8234];
      }
      var v8235 = p11119[vLN01338] & 31;
      f1344(p11117, p11126, v8230[v8235]);
      p11126 += v8231[v8235];
      if (v8235 > 3) {
        f1344(p11117, p11126, p11119[vLN01338] >>> 5 & 8191);
        p11126 += v8132[v8235];
      }
    } else {
      f1344(p11117, p11126, v8228[p11119[vLN01338]]);
      p11126 += v8229[p11119[vLN01338]];
    }
  }
  f1344(p11117, p11126, v8228[256]);
  return p11126 + v8229[256];
}
var v8236 = new vUint32Array([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]);
var v8237 = new vUint8Array(0);
function f1352(p11127, p11128, p11129, p11130, p11131, p11132) {
  var v8238 = p11127.length;
  var v8239 = new vUint8Array(p11130 + v8238 + (1 + Math.ceil(v8238 / 7000)) * 5 + p11131);
  var v8240 = v8239.subarray(p11130, v8239.length - p11131);
  var vLN01339 = 0;
  if (!p11128 || v8238 < 8) {
    for (var vLN01343 = 0; vLN01343 <= v8238; vLN01343 += 65535) {
      var v8241 = vLN01343 + 65535;
      if (v8241 < v8238) {
        vLN01339 = f1350(v8240, vLN01339, p11127.subarray(vLN01343, v8241));
      } else {
        v8240[vLN01343] = p11132;
        vLN01339 = f1350(v8240, vLN01339, p11127.subarray(vLN01343, v8238));
      }
    }
  } else {
    var v8242 = v8236[p11128 - 1];
    var v8243 = v8242 >>> 13;
    var v8244 = v8242 & 8191;
    var v8245 = (1 << p11129) - 1;
    var v8246 = new vUint16Array(32768);
    var v8247 = new vUint16Array(v8245 + 1);
    var v8248 = Math.ceil(p11129 / 3);
    var v8249 = v8248 * 2;
    function f1353(p11133) {
      return (p11127[p11133] ^ p11127[p11133 + 1] << v8248 ^ p11127[p11133 + 2] << v8249) & v8245;
    }
    var v8250 = new vUint32Array(25000);
    var v8251 = new vUint16Array(288);
    var v8252 = new vUint16Array(32);
    var vLN01341 = 0;
    var vLN01342 = 0;
    var vLN01343 = 0;
    var vLN01344 = 0;
    var vLN01345 = 0;
    var vLN01346 = 0;
    for (; vLN01343 < v8238; ++vLN01343) {
      var vF13532 = f1353(vLN01343);
      var v8253 = vLN01343 & 32767;
      var v8254 = v8247[vF13532];
      v8246[v8253] = v8254;
      v8247[vF13532] = v8253;
      if (vLN01345 <= vLN01343) {
        var v8255 = v8238 - vLN01343;
        if ((vLN01341 > 7000 || vLN01344 > 24576) && v8255 > 423) {
          vLN01339 = f1351(p11127, v8240, 0, v8250, v8251, v8252, vLN01342, vLN01344, vLN01346, vLN01343 - vLN01346, vLN01339);
          vLN01344 = vLN01341 = vLN01342 = 0;
          vLN01346 = vLN01343;
          for (var vLN01352 = 0; vLN01352 < 286; ++vLN01352) {
            v8251[vLN01352] = 0;
          }
          for (var vLN01352 = 0; vLN01352 < 30; ++vLN01352) {
            v8252[vLN01352] = 0;
          }
        }
        var vLN219 = 2;
        var vLN01349 = 0;
        var vV8244 = v8244;
        var v8256 = v8253 - v8254 & 32767;
        if (v8255 > 2 && vF13532 == f1353(vLN01343 - v8256)) {
          var v8257 = Math.min(v8243, v8255) - 1;
          var v8258 = Math.min(32767, vLN01343);
          var v8259 = Math.min(258, v8255);
          while (v8256 <= v8258 && --vV8244 && v8253 != v8254) {
            if (p11127[vLN01343 + vLN219] == p11127[vLN01343 + vLN219 - v8256]) {
              var vLN01350 = 0;
              for (; vLN01350 < v8259 && p11127[vLN01343 + vLN01350] == p11127[vLN01343 + vLN01350 - v8256]; ++vLN01350) {
                ;
              }
              if (vLN01350 > vLN219) {
                vLN219 = vLN01350;
                vLN01349 = v8256;
                if (vLN01350 > v8257) {
                  break;
                }
                var v8260 = Math.min(v8256, vLN01350 - 2);
                var vLN01351 = 0;
                for (var vLN01352 = 0; vLN01352 < v8260; ++vLN01352) {
                  var v8261 = vLN01343 - v8256 + vLN01352 + 32768 & 32767;
                  var v8262 = v8246[v8261];
                  var v8263 = v8261 - v8262 + 32768 & 32767;
                  if (v8263 > vLN01351) {
                    vLN01351 = v8263;
                    v8254 = v8261;
                  }
                }
              }
            }
            v8253 = v8254;
            v8254 = v8246[v8253];
            v8256 += v8253 - v8254 + 32768 & 32767;
          }
        }
        if (vLN01349) {
          v8250[vLN01344++] = v8138[vLN219] << 18 | 268435456 | v8140[vLN01349];
          var v8264 = v8138[vLN219] & 31;
          var v8265 = v8140[vLN01349] & 31;
          vLN01342 += v8131[v8264] + v8132[v8265];
          ++v8251[257 + v8264];
          ++v8252[v8265];
          vLN01345 = vLN01343 + vLN219;
          ++vLN01341;
        } else {
          v8250[vLN01344++] = p11127[vLN01343];
          ++v8251[p11127[vLN01343]];
        }
      }
    }
    vLN01339 = f1351(p11127, v8240, p11132, v8250, v8251, v8252, vLN01342, vLN01344, vLN01346, vLN01343 - vLN01346, vLN01339);
    if (!p11132 && vLN01339 & 7) {
      vLN01339 = f1350(v8240, vLN01339 + 1, v8237);
    }
  }
  return f1340(v8239, 0, p11130 + f1339(vLN01339) + p11131);
}
var vF55 = function () {
  var v8266 = new vUint32Array(256);
  for (var vLN01353 = 0; vLN01353 < 256; ++vLN01353) {
    var vVLN01353 = vLN01353;
    var vLN9 = 9;
    while (--vLN9) {
      vVLN01353 = (vVLN01353 & 1 && 3988292384) ^ vVLN01353 >>> 1;
    }
    v8266[vLN01353] = vVLN01353;
  }
  return v8266;
}();
function f1354() {
  var v8267 = -1;
  return {
    p: function (p11134) {
      var vV8267 = v8267;
      for (var vLN01354 = 0; vLN01354 < p11134.length; ++vLN01354) {
        vV8267 = vF55[vV8267 & 255 ^ p11134[vLN01354]] ^ vV8267 >>> 8;
      }
      v8267 = vV8267;
    },
    d: function () {
      return ~v8267;
    }
  };
}
function f1355() {
  var vLN1122 = 1;
  var vLN01355 = 0;
  return {
    p: function (p11135) {
      var vVLN1122 = vLN1122;
      var vVLN01355 = vLN01355;
      var v8268 = p11135.length;
      for (var vLN01356 = 0; vLN01356 != v8268;) {
        var v8269 = Math.min(vLN01356 + 2655, v8268);
        for (; vLN01356 < v8269; ++vLN01356) {
          vVLN01355 += vVLN1122 += p11135[vLN01356];
        }
        vVLN1122 = (vVLN1122 & 65535) + (vVLN1122 >> 16) * 15;
        vVLN01355 = (vVLN01355 & 65535) + (vVLN01355 >> 16) * 15;
      }
      vLN1122 = vVLN1122;
      vLN01355 = vVLN01355;
    },
    d: function () {
      vLN1122 %= 65521;
      vLN01355 %= 65521;
      return (vLN1122 & 255) << 24 | vLN1122 >>> 8 << 16 | (vLN01355 & 255) << 8 | vLN01355 >>> 8;
    }
  };
}
;
function f1356(p11136, p11137, p11138, p11139, p11140) {
  return f1352(p11136, p11137.level == null ? 6 : p11137.level, p11137.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(p11136.length))) * 1.5) : 12 + p11137.mem, p11138, p11139, !p11140);
}
function f1357(p11141, p11142) {
  var vO241 = {};
  for (var v8271 in p11141) {
    vO241[v8271] = p11141[v8271];
  }
  for (var v8271 in p11142) {
    vO241[v8271] = p11142[v8271];
  }
  return vO241;
}
function f1358(p11143, p11144, p11145) {
  var vP11143 = p11143();
  var v8272 = p11143.toString();
  var v8273 = v8272.slice(v8272.indexOf("[") + 1, v8272.lastIndexOf("]")).replace(/ /g, "").split(",");
  for (var vLN01357 = 0; vLN01357 < vP11143.length; ++vLN01357) {
    var v8274 = vP11143[vLN01357];
    var v8275 = v8273[vLN01357];
    if (typeof v8274 == "function") {
      p11144 += ";" + v8275 + "=";
      var v8276 = v8274.toString();
      if (v8274.prototype) {
        if (v8276.indexOf("[native code]") != -1) {
          var v8277 = v8276.indexOf(" ", 8) + 1;
          p11144 += v8276.slice(v8277, v8276.indexOf("(", v8277));
        } else {
          p11144 += v8276;
          for (var v8278 in v8274.prototype) {
            p11144 += ";" + v8275 + ".prototype." + v8278 + "=" + v8274.prototype[v8278].toString();
          }
        }
      } else {
        p11144 += v8276;
      }
    } else {
      p11145[v8275] = v8274;
    }
  }
  return [p11144, p11145];
}
var vA417 = [];
function f1359(p11146) {
  var vA418 = [];
  for (var v8279 in p11146) {
    if (p11146[v8279] instanceof vUint8Array || p11146[v8279] instanceof vUint16Array || p11146[v8279] instanceof vUint32Array) {
      vA418.push((p11146[v8279] = new p11146[v8279].constructor(p11146[v8279])).buffer);
    }
  }
  return vA418;
}
function f1360(p11147, p11148, p11149, p11150) {
  var v8280;
  if (!vA417[p11149]) {
    var vLS30 = "";
    var vO242 = {};
    var v8281 = p11147.length - 1;
    for (var vLN01358 = 0; vLN01358 < v8281; ++vLN01358) {
      v8280 = f1358(p11147[vLN01358], vLS30, vO242);
      vLS30 = v8280[0];
      vO242 = v8280[1];
    }
    vA417[p11149] = f1358(p11147[v8281], vLS30, vO242);
  }
  var vF1357 = f1357({}, vA417[p11149][1]);
  return f1333(vA417[p11149][0] + ";onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=" + p11148.toString() + "}", p11149, vF1357, f1359(vF1357), p11150);
}
function f1361() {
  return [vUint8Array, vUint16Array, vUint32Array, v8131, v8132, v8133, v8137, v8139, vF13352, vF13354, v8141, f1335, f1336, f1337, f1338, f1339, f1340, f1341, f1390, f1367, f1368];
}
function f1362() {
  return [vUint8Array, vUint16Array, vUint32Array, v8131, v8132, v8133, v8138, v8140, vF1335, v8152, vF13353, v8153, v8141, v8236, v8237, f1335, f1343, f1344, f1345, f1346, f1347, f1349, f1350, f1351, f1339, f1340, f1352, f1356, f1386, f1367];
}
function f1363() {
  return [f1376, f1379, f1375, f1354, vF55];
}
function f1364() {
  return [f1377, f1378];
}
function f1365() {
  return [f1380, f1375, f1355];
}
function f1366() {
  return [f1381];
}
function f1367(p11151) {
  return postMessage(p11151, [p11151.buffer]);
}
function f1368(p11152) {
  return p11152 && p11152.size && new vUint8Array(p11152.size);
}
function f1369(p11153, p11154, p11155, p11156, p11157, p11158) {
  var vF1360 = f1360(p11155, p11156, p11157, function (p11159, p11160) {
    vF1360.terminate();
    p11158(p11159, p11160);
  });
  vF1360.postMessage([p11153, p11154], p11154.consume ? [p11153.buffer] : []);
  return function () {
    vF1360.terminate();
  };
}
function f1370(p11161) {
  p11161.ondata = function (p11162, p11163) {
    return postMessage([p11162, p11163], [p11162.buffer]);
  };
  return function (p11164) {
    return p11161.push(p11164.data[0], p11164.data[1]);
  };
}
function f1371(p11165, p11166, p11167, p11168, p11169) {
  var v8282;
  var vF13602 = f1360(p11165, p11168, p11169, function (p11170, p11171) {
    if (p11170) {
      vF13602.terminate();
      p11166.ondata.call(p11166, p11170);
    } else {
      if (p11171[1]) {
        vF13602.terminate();
      }
      p11166.ondata.call(p11166, p11170, p11171[0], p11171[1]);
    }
  });
  vF13602.postMessage(p11167);
  p11166.push = function (p11172, p11173) {
    if (v8282) {
      throw "stream finished";
    }
    if (!p11166.ondata) {
      throw "no stream handler";
    }
    vF13602.postMessage([p11172, v8282 = p11173], [p11172.buffer]);
  };
  p11166.terminate = function () {
    vF13602.terminate();
  };
}
function f1372(p11174, p11175) {
  return p11174[p11175] | p11174[p11175 + 1] << 8;
}
function f1373(p11176, p11177) {
  return (p11176[p11177] | p11176[p11177 + 1] << 8 | p11176[p11177 + 2] << 16 | p11176[p11177 + 3] << 24) >>> 0;
}
function f1374(p11178, p11179) {
  return f1373(p11178, p11179) + f1373(p11178, p11179 + 4) * 4294967296;
}
function f1375(p11180, p11181, p11182) {
  for (; p11182; ++p11181) {
    p11180[p11181] = p11182;
    p11182 >>>= 8;
  }
}
function f1376(p11183, p11184) {
  var v8283 = p11184.filename;
  p11183[0] = 31;
  p11183[1] = 139;
  p11183[2] = 8;
  p11183[8] = p11184.level < 2 ? 4 : p11184.level == 9 ? 2 : 0;
  p11183[9] = 3;
  if (p11184.mtime != 0) {
    f1375(p11183, 4, Math.floor(new Date(p11184.mtime || Date.now()) / 1000));
  }
  if (v8283) {
    p11183[3] = 8;
    for (var vLN01359 = 0; vLN01359 <= v8283.length; ++vLN01359) {
      p11183[vLN01359 + 10] = v8283.charCodeAt(vLN01359);
    }
  }
}
function f1377(p11185) {
  if (p11185[0] != 31 || p11185[1] != 139 || p11185[2] != 8) {
    throw "invalid gzip data";
  }
  var v8284 = p11185[3];
  var vLN105 = 10;
  if (v8284 & 4) {
    vLN105 += p11185[10] | (p11185[11] << 8) + 2;
  }
  for (var v8285 = (v8284 >> 3 & 1) + (v8284 >> 4 & 1); v8285 > 0; v8285 -= !p11185[vLN105++]) {
    ;
  }
  return vLN105 + (v8284 & 2);
}
function f1378(p11186) {
  var v8286 = p11186.length;
  return (p11186[v8286 - 4] | p11186[v8286 - 3] << 8 | p11186[v8286 - 2] << 16 | p11186[v8286 - 1] << 24) >>> 0;
}
function f1379(p11187) {
  return 10 + (p11187.filename && p11187.filename.length + 1 || 0);
}
function f1380(p11188, p11189) {
  var v8287 = p11189.level;
  var v8288 = v8287 == 0 ? 0 : v8287 < 6 ? 1 : v8287 == 9 ? 3 : 2;
  p11188[0] = 120;
  p11188[1] = v8288 << 6 | (v8288 ? 32 - v8288 * 2 : 1);
}
function f1381(p11190) {
  if ((p11190[0] & 15) != 8 || p11190[0] >>> 4 > 7 || (p11190[0] << 8 | p11190[1]) % 31) {
    throw "invalid zlib data";
  }
  if (p11190[1] & 32) {
    throw "invalid zlib data: preset dictionaries not supported";
  }
}
function f1382(p11191, p11192) {
  if (!p11192 && typeof p11191 == "function") {
    p11192 = p11191;
    p11191 = {};
  }
  this.ondata = p11192;
  return p11191;
}
var vF56 = function () {
  function f1383(p11193, p11194) {
    if (!p11194 && typeof p11193 == "function") {
      p11194 = p11193;
      p11193 = {};
    }
    this.ondata = p11194;
    this.o = p11193 || {};
  }
  f1383.prototype.p = function (p11195, p11196) {
    this.ondata(f1356(p11195, this.o, 0, 0, !p11196), p11196);
  };
  f1383.prototype.push = function (p11197, p11198) {
    if (this.d) {
      throw "stream finished";
    }
    if (!this.ondata) {
      throw "no stream handler";
    }
    this.d = p11198;
    this.p(p11197, p11198 || false);
  };
  return f1383;
}();
var vF57 = function () {
  function f1384(p11199, p11200) {
    f1371([f1362, function () {
      return [f1370, vF56];
    }], this, f1382.call(this, p11199, p11200), function (p11201) {
      var v8289 = new vF56(p11201.data);
      onmessage = f1370(v8289);
    }, 6);
  }
  return f1384;
}();
function f1385(p11202, p11203, p11204) {
  if (!p11204) {
    p11204 = p11203;
    p11203 = {};
  }
  if (typeof p11204 != "function") {
    throw "no callback";
  }
  return f1369(p11202, p11203, [f1362], function (p11205) {
    return f1367(f1386(p11205.data[0], p11205.data[1]));
  }, 0, p11204);
}
function f1386(p11206, p11207) {
  return f1356(p11206, p11207 || {}, 0, 0);
}
var vF58 = function () {
  function f1387(p11208) {
    this.s = {};
    this.p = new vUint8Array(0);
    this.ondata = p11208;
  }
  f1387.prototype.e = function (p11209) {
    if (this.d) {
      throw "stream finished";
    }
    if (!this.ondata) {
      throw "no stream handler";
    }
    var v8290 = this.p.length;
    var v8291 = new vUint8Array(v8290 + p11209.length);
    v8291.set(this.p);
    v8291.set(p11209, v8290);
    this.p = v8291;
  };
  f1387.prototype.c = function (p11210) {
    this.d = this.s.i = p11210 || false;
    var v8292 = this.s.b;
    var vF1341 = f1341(this.p, this.o, this.s);
    this.ondata(f1340(vF1341, v8292, this.s.b), this.d);
    this.o = f1340(vF1341, this.s.b - 32768);
    this.s.b = this.o.length;
    this.p = f1340(this.p, this.s.p / 8 | 0);
    this.s.p &= 7;
  };
  f1387.prototype.push = function (p11211, p11212) {
    this.e(p11211);
    this.c(p11212);
  };
  return f1387;
}();
var vF59 = function () {
  function f1388(p11213) {
    this.ondata = p11213;
    f1371([f1361, function () {
      return [f1370, vF58];
    }], this, 0, function () {
      var v8293 = new vF58();
      onmessage = f1370(v8293);
    }, 7);
  }
  return f1388;
}();
function f1389(p11214, p11215, p11216) {
  if (!p11216) {
    p11216 = p11215;
    p11215 = {};
  }
  if (typeof p11216 != "function") {
    throw "no callback";
  }
  return f1369(p11214, p11215, [f1361], function (p11217) {
    return f1367(f1390(p11217.data[0], f1368(p11217.data[1])));
  }, 1, p11216);
}
function f1390(p11218, p11219) {
  return f1341(p11218, p11219);
}
var vF60 = function () {
  function f1391(p11220, p11221) {
    this.c = f1354();
    this.l = 0;
    this.v = 1;
    vF56.call(this, p11220, p11221);
  }
  f1391.prototype.push = function (p11222, p11223) {
    vF56.prototype.push.call(this, p11222, p11223);
  };
  f1391.prototype.p = function (p11224, p11225) {
    this.c.p(p11224);
    this.l += p11224.length;
    var vF13562 = f1356(p11224, this.o, this.v && f1379(this.o), p11225 && 8, !p11225);
    if (this.v) {
      f1376(vF13562, this.o);
      this.v = 0;
    }
    if (p11225) {
      f1375(vF13562, vF13562.length - 8, this.c.d());
      f1375(vF13562, vF13562.length - 4, this.l);
    }
    this.ondata(vF13562, p11225);
  };
  return f1391;
}();
var vF61 = function () {
  function f1392(p11226, p11227) {
    f1371([f1362, f1363, function () {
      return [f1370, vF56, vF60];
    }], this, f1382.call(this, p11226, p11227), function (p11228) {
      var v8294 = new vF60(p11228.data);
      onmessage = f1370(v8294);
    }, 8);
  }
  return f1392;
}();
function f1393(p11229, p11230, p11231) {
  if (!p11231) {
    p11231 = p11230;
    p11230 = {};
  }
  if (typeof p11231 != "function") {
    throw "no callback";
  }
  return f1369(p11229, p11230, [f1362, f1363, function () {
    return [f1394];
  }], function (p11232) {
    return f1367(f1394(p11232.data[0], p11232.data[1]));
  }, 2, p11231);
}
function f1394(p11233, p11234) {
  if (!p11234) {
    p11234 = {};
  }
  var vF13542 = f1354();
  var v8295 = p11233.length;
  vF13542.p(p11233);
  var vF13563 = f1356(p11233, p11234, f1379(p11234), 8);
  var v8296 = vF13563.length;
  f1376(vF13563, p11234);
  f1375(vF13563, v8296 - 8, vF13542.d());
  f1375(vF13563, v8296 - 4, v8295);
  return vF13563;
}
var vF62 = function () {
  function f1395(p11235) {
    this.v = 1;
    vF58.call(this, p11235);
  }
  f1395.prototype.push = function (p11236, p11237) {
    vF58.prototype.e.call(this, p11236);
    if (this.v) {
      var v8297 = this.p.length > 3 ? f1377(this.p) : 4;
      if (v8297 >= this.p.length && !p11237) {
        return;
      }
      this.p = this.p.subarray(v8297);
      this.v = 0;
    }
    if (p11237) {
      if (this.p.length < 8) {
        throw "invalid gzip stream";
      }
      this.p = this.p.subarray(0, -8);
    }
    vF58.prototype.c.call(this, p11237);
  };
  return f1395;
}();
var vF63 = function () {
  function f1396(p11238) {
    this.ondata = p11238;
    f1371([f1361, f1364, function () {
      return [f1370, vF58, vF62];
    }], this, 0, function () {
      var v8298 = new vF62();
      onmessage = f1370(v8298);
    }, 9);
  }
  return f1396;
}();
function f1397(p11239, p11240, p11241) {
  if (!p11241) {
    p11241 = p11240;
    p11240 = {};
  }
  if (typeof p11241 != "function") {
    throw "no callback";
  }
  return f1369(p11239, p11240, [f1361, f1364, function () {
    return [f1398];
  }], function (p11242) {
    return f1367(f1398(p11242.data[0]));
  }, 3, p11241);
}
function f1398(p11243, p11244) {
  return f1341(p11243.subarray(f1377(p11243), -8), p11244 || new vUint8Array(f1378(p11243)));
}
var vF64 = function () {
  function f1399(p11245, p11246) {
    this.c = f1355();
    this.v = 1;
    vF56.call(this, p11245, p11246);
  }
  f1399.prototype.push = function (p11247, p11248) {
    vF56.prototype.push.call(this, p11247, p11248);
  };
  f1399.prototype.p = function (p11249, p11250) {
    this.c.p(p11249);
    var vF13564 = f1356(p11249, this.o, this.v && 2, p11250 && 4, !p11250);
    if (this.v) {
      f1380(vF13564, this.o);
      this.v = 0;
    }
    if (p11250) {
      f1375(vF13564, vF13564.length - 4, this.c.d());
    }
    this.ondata(vF13564, p11250);
  };
  return f1399;
}();
var vF65 = function () {
  function f1400(p11251, p11252) {
    f1371([f1362, f1365, function () {
      return [f1370, vF56, vF64];
    }], this, f1382.call(this, p11251, p11252), function (p11253) {
      var v8299 = new vF64(p11253.data);
      onmessage = f1370(v8299);
    }, 10);
  }
  return f1400;
}();
function f1401(p11254, p11255, p11256) {
  if (!p11256) {
    p11256 = p11255;
    p11255 = {};
  }
  if (typeof p11256 != "function") {
    throw "no callback";
  }
  return f1369(p11254, p11255, [f1362, f1365, function () {
    return [f1402];
  }], function (p11257) {
    return f1367(f1402(p11257.data[0], p11257.data[1]));
  }, 4, p11256);
}
function f1402(p11258, p11259) {
  if (!p11259) {
    p11259 = {};
  }
  var vF13552 = f1355();
  vF13552.p(p11258);
  var vF13565 = f1356(p11258, p11259, 2, 4);
  f1380(vF13565, p11259);
  f1375(vF13565, vF13565.length - 4, vF13552.d());
  return vF13565;
}
var vF66 = function () {
  function f1403(p11260) {
    this.v = 1;
    vF58.call(this, p11260);
  }
  f1403.prototype.push = function (p11261, p11262) {
    vF58.prototype.e.call(this, p11261);
    if (this.v) {
      if (this.p.length < 2 && !p11262) {
        return;
      }
      this.p = this.p.subarray(2);
      this.v = 0;
    }
    if (p11262) {
      if (this.p.length < 4) {
        throw "invalid zlib stream";
      }
      this.p = this.p.subarray(0, -4);
    }
    vF58.prototype.c.call(this, p11262);
  };
  return f1403;
}();
var vF67 = function () {
  function f1404(p11263) {
    this.ondata = p11263;
    f1371([f1361, f1366, function () {
      return [f1370, vF58, vF66];
    }], this, 0, function () {
      var v8300 = new vF66();
      onmessage = f1370(v8300);
    }, 11);
  }
  return f1404;
}();
function f1405(p11264, p11265, p11266) {
  if (!p11266) {
    p11266 = p11265;
    p11265 = {};
  }
  if (typeof p11266 != "function") {
    throw "no callback";
  }
  return f1369(p11264, p11265, [f1361, f1366, function () {
    return [f1406];
  }], function (p11267) {
    return f1367(f1406(p11267.data[0], f1368(p11267.data[1])));
  }, 5, p11266);
}
function f1406(p11268, p11269) {
  return f1341((f1381(p11268), p11268.subarray(2, -4)), p11269);
}
var vF68 = function () {
  function f1407(p11270) {
    this.G = vF62;
    this.I = vF58;
    this.Z = vF66;
    this.ondata = p11270;
  }
  f1407.prototype.push = function (p11271, p11272) {
    if (!this.ondata) {
      throw "no stream handler";
    }
    if (!this.s) {
      if (this.p && this.p.length) {
        var v8301 = new vUint8Array(this.p.length + p11271.length);
        v8301.set(this.p);
        v8301.set(p11271, this.p.length);
      } else {
        this.p = p11271;
      }
      if (this.p.length > 2) {
        var vThis62 = this;
        function f1408() {
          vThis62.ondata.apply(vThis62, arguments);
        }
        this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(f1408) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(f1408) : new this.Z(f1408);
        this.s.push(this.p, p11272);
        this.p = null;
      }
    } else {
      this.s.push(p11271, p11272);
    }
  };
  return f1407;
}();
var vF69 = function () {
  function f1409(p11273) {
    this.G = vF63;
    this.I = vF59;
    this.Z = vF67;
    this.ondata = p11273;
  }
  f1409.prototype.push = function (p11274, p11275) {
    vF68.prototype.push.call(this, p11274, p11275);
  };
  return f1409;
}();
function f1410(p11276, p11277, p11278) {
  if (!p11278) {
    p11278 = p11277;
    p11277 = {};
  }
  if (typeof p11278 != "function") {
    throw "no callback";
  }
  if (p11276[0] == 31 && p11276[1] == 139 && p11276[2] == 8) {
    return f1397(p11276, p11277, p11278);
  } else if ((p11276[0] & 15) != 8 || p11276[0] >> 4 > 7 || (p11276[0] << 8 | p11276[1]) % 31) {
    return f1389(p11276, p11277, p11278);
  } else {
    return f1405(p11276, p11277, p11278);
  }
}
function f1411(p11279, p11280) {
  if (p11279[0] == 31 && p11279[1] == 139 && p11279[2] == 8) {
    return f1398(p11279, p11280);
  } else if ((p11279[0] & 15) != 8 || p11279[0] >> 4 > 7 || (p11279[0] << 8 | p11279[1]) % 31) {
    return f1390(p11279, p11280);
  } else {
    return f1406(p11279, p11280);
  }
}
function f1412(p11281, p11282, p11283, p11284) {
  for (var v8302 in p11281) {
    var v8303 = p11281[v8302];
    var v8304 = p11282 + v8302;
    if (v8303 instanceof vUint8Array) {
      p11283[v8304] = [v8303, p11284];
    } else if (Array.isArray(v8303)) {
      p11283[v8304] = [v8303[0], f1357(p11284, v8303[1])];
    } else {
      f1412(v8303, v8304 + "/", p11283, p11284);
    }
  }
}
var v8305 = typeof TextEncoder != "undefined" && new TextEncoder();
var v8306 = typeof TextDecoder != "undefined" && new TextDecoder();
var vLN01360 = 0;
try {
  v8306.decode(v8237, {
    stream: true
  });
  vLN01360 = 1;
} catch (e76) {}
function f1413(p11285) {
  var vLS31 = "";
  var vLN01361 = 0;
  while (true) {
    var v8307 = p11285[vLN01361++];
    var v8308 = (v8307 > 127) + (v8307 > 223) + (v8307 > 239);
    if (vLN01361 + v8308 > p11285.length) {
      return [vLS31, f1340(p11285, vLN01361 - 1)];
    }
    if (!v8308) {
      vLS31 += String.fromCharCode(v8307);
    } else if (v8308 == 3) {
      v8307 = ((v8307 & 15) << 18 | (p11285[vLN01361++] & 63) << 12 | (p11285[vLN01361++] & 63) << 6 | p11285[vLN01361++] & 63) - 65536;
      vLS31 += String.fromCharCode(v8307 >> 10 | 55296, v8307 & 1023 | 56320);
    } else if (v8308 & 1) {
      vLS31 += String.fromCharCode((v8307 & 31) << 6 | p11285[vLN01361++] & 63);
    } else {
      vLS31 += String.fromCharCode((v8307 & 15) << 12 | (p11285[vLN01361++] & 63) << 6 | p11285[vLN01361++] & 63);
    }
  }
}
var vF70 = function () {
  function f1414(p11286) {
    this.ondata = p11286;
    if (vLN01360) {
      this.t = new TextDecoder();
    } else {
      this.p = v8237;
    }
  }
  f1414.prototype.push = function (p11287, p11288) {
    if (!this.ondata) {
      throw "no callback";
    }
    p11288 = !!p11288;
    if (this.t) {
      this.ondata(this.t.decode(p11287, {
        stream: true
      }), p11288);
      if (p11288) {
        if (this.t.decode().length) {
          throw "invalid utf-8 data";
        }
        this.t = null;
      }
      return;
    }
    if (!this.p) {
      throw "stream finished";
    }
    var v8309 = new vUint8Array(this.p.length + p11287.length);
    v8309.set(this.p);
    v8309.set(p11287, this.p.length);
    var vF1413 = f1413(v8309);
    var v8310 = vF1413[0];
    var v8311 = vF1413[1];
    if (p11288) {
      if (v8311.length) {
        throw "invalid utf-8 data";
      }
      this.p = null;
    } else {
      this.p = v8311;
    }
    this.ondata(v8310, p11288);
  };
  return f1414;
}();
var vF71 = function () {
  function f1415(p11289) {
    this.ondata = p11289;
  }
  f1415.prototype.push = function (p11290, p11291) {
    if (!this.ondata) {
      throw "no callback";
    }
    if (this.d) {
      throw "stream finished";
    }
    this.ondata(f1416(p11290), this.d = p11291 || false);
  };
  return f1415;
}();
function f1416(p11292, p11293) {
  if (p11293) {
    var v8312 = new vUint8Array(p11292.length);
    for (var vLN01364 = 0; vLN01364 < p11292.length; ++vLN01364) {
      v8312[vLN01364] = p11292.charCodeAt(vLN01364);
    }
    return v8312;
  }
  if (v8305) {
    return v8305.encode(p11292);
  }
  var v8313 = p11292.length;
  var v8314 = new vUint8Array(p11292.length + (p11292.length >> 1));
  var vLN01363 = 0;
  function f1417(p11294) {
    v8314[vLN01363++] = p11294;
  }
  for (var vLN01364 = 0; vLN01364 < v8313; ++vLN01364) {
    if (vLN01363 + 5 > v8314.length) {
      var v8315 = new vUint8Array(vLN01363 + 8 + (v8313 - vLN01364 << 1));
      v8315.set(v8314);
      v8314 = v8315;
    }
    var v8316 = p11292.charCodeAt(vLN01364);
    if (v8316 < 128 || p11293) {
      f1417(v8316);
    } else if (v8316 < 2048) {
      f1417(v8316 >> 6 | 192);
      f1417(v8316 & 63 | 128);
    } else if (v8316 > 55295 && v8316 < 57344) {
      v8316 = 65536 + (v8316 & 1047552) | p11292.charCodeAt(++vLN01364) & 1023;
      f1417(v8316 >> 18 | 240);
      f1417(v8316 >> 12 & 63 | 128);
      f1417(v8316 >> 6 & 63 | 128);
      f1417(v8316 & 63 | 128);
    } else {
      f1417(v8316 >> 12 | 224);
      f1417(v8316 >> 6 & 63 | 128);
      f1417(v8316 & 63 | 128);
    }
  }
  return f1340(v8314, 0, vLN01363);
}
function f1418(p11295, p11296) {
  if (p11296) {
    var vLS32 = "";
    for (var vLN01365 = 0; vLN01365 < p11295.length; vLN01365 += 16384) {
      vLS32 += String.fromCharCode.apply(null, p11295.subarray(vLN01365, vLN01365 + 16384));
    }
    return vLS32;
  } else if (v8306) {
    return v8306.decode(p11295);
  } else {
    var vF14132 = f1413(p11295);
    var v8317 = vF14132[0];
    var v8318 = vF14132[1];
    if (v8318.length) {
      throw "invalid utf-8 data";
    }
    return v8317;
  }
}
;
function f1419(p11297) {
  if (p11297 == 1) {
    return 3;
  } else if (p11297 < 6) {
    return 2;
  } else if (p11297 == 9) {
    return 1;
  } else {
    return 0;
  }
}
function f1420(p11298, p11299) {
  return p11299 + 30 + f1372(p11298, p11299 + 26) + f1372(p11298, p11299 + 28);
}
function f1421(p11300, p11301, p11302) {
  var vF1372 = f1372(p11300, p11301 + 28);
  var vF1418 = f1418(p11300.subarray(p11301 + 46, p11301 + 46 + vF1372), !(f1372(p11300, p11301 + 8) & 2048));
  var v8319 = p11301 + 46 + vF1372;
  var vF1373 = f1373(p11300, p11301 + 20);
  var v8320 = p11302 && vF1373 == 4294967295 ? f1422(p11300, v8319) : [vF1373, f1373(p11300, p11301 + 24), f1373(p11300, p11301 + 42)];
  var v8321 = v8320[0];
  var v8322 = v8320[1];
  var v8323 = v8320[2];
  return [f1372(p11300, p11301 + 10), v8321, v8322, vF1418, v8319 + f1372(p11300, p11301 + 30) + f1372(p11300, p11301 + 32), v8323];
}
function f1422(p11303, p11304) {
  for (; f1372(p11303, p11304) != 1; p11304 += 4 + f1372(p11303, p11304 + 2)) {
    ;
  }
  return [f1374(p11303, p11304 + 12), f1374(p11303, p11304 + 4), f1374(p11303, p11304 + 20)];
}
function f1423(p11305) {
  var vLN01366 = 0;
  if (p11305) {
    for (var v8324 in p11305) {
      var v8325 = p11305[v8324].length;
      if (v8325 > 65535) {
        throw "extra field too long";
      }
      vLN01366 += v8325 + 4;
    }
  }
  return vLN01366;
}
function f1424(p11306, p11307, p11308, p11309, p11310, p11311, p11312, p11313) {
  var v8326 = p11309.length;
  var v8327 = p11308.extra;
  var v8328 = p11313 && p11313.length;
  var vF1423 = f1423(v8327);
  f1375(p11306, p11307, p11312 != null ? 33639248 : 67324752);
  p11307 += 4;
  if (p11312 != null) {
    p11306[p11307++] = 20;
    p11306[p11307++] = p11308.os;
  }
  p11306[p11307] = 20;
  p11307 += 2;
  p11306[p11307++] = p11308.flag << 1 | (p11311 == null && 8);
  p11306[p11307++] = p11310 && 8;
  p11306[p11307++] = p11308.compression & 255;
  p11306[p11307++] = p11308.compression >> 8;
  var v8329 = new Date(p11308.mtime == null ? Date.now() : p11308.mtime);
  var v8330 = v8329.getFullYear() - 1980;
  if (v8330 < 0 || v8330 > 119) {
    throw "date not in range 1980-2099";
  }
  f1375(p11306, p11307, v8330 << 25 | v8329.getMonth() + 1 << 21 | v8329.getDate() << 16 | v8329.getHours() << 11 | v8329.getMinutes() << 5 | v8329.getSeconds() >>> 1);
  p11307 += 4;
  if (p11311 != null) {
    f1375(p11306, p11307, p11308.crc);
    f1375(p11306, p11307 + 4, p11311);
    f1375(p11306, p11307 + 8, p11308.size);
  }
  f1375(p11306, p11307 + 12, v8326);
  f1375(p11306, p11307 + 14, vF1423);
  p11307 += 16;
  if (p11312 != null) {
    f1375(p11306, p11307, v8328);
    f1375(p11306, p11307 + 6, p11308.attrs);
    f1375(p11306, p11307 + 10, p11312);
    p11307 += 14;
  }
  p11306.set(p11309, p11307);
  p11307 += v8326;
  if (vF1423) {
    for (var v8331 in v8327) {
      var v8332 = v8327[v8331];
      var v8333 = v8332.length;
      f1375(p11306, p11307, +v8331);
      f1375(p11306, p11307 + 2, v8333);
      p11306.set(v8332, p11307 + 4);
      p11307 += 4 + v8333;
    }
  }
  if (v8328) {
    p11306.set(p11313, p11307);
    p11307 += v8328;
  }
  return p11307;
}
function f1425(p11314, p11315, p11316, p11317, p11318) {
  f1375(p11314, p11315, 101010256);
  f1375(p11314, p11315 + 8, p11316);
  f1375(p11314, p11315 + 10, p11316);
  f1375(p11314, p11315 + 12, p11317);
  f1375(p11314, p11315 + 16, p11318);
}
var vF72 = function () {
  function f1426(p11319) {
    this.filename = p11319;
    this.c = f1354();
    this.size = 0;
    this.compression = 0;
  }
  f1426.prototype.process = function (p11320, p11321) {
    this.ondata(null, p11320, p11321);
  };
  f1426.prototype.push = function (p11322, p11323) {
    if (!this.ondata) {
      throw "no callback - add to ZIP archive before pushing";
    }
    this.c.p(p11322);
    this.size += p11322.length;
    if (p11323) {
      this.crc = this.c.d();
    }
    this.process(p11322, p11323 || false);
  };
  return f1426;
}();
var vF73 = function () {
  function f1427(p11324, p11325) {
    var vThis63 = this;
    if (!p11325) {
      p11325 = {};
    }
    vF72.call(this, p11324);
    this.d = new vF56(p11325, function (p11326, p11327) {
      vThis63.ondata(null, p11326, p11327);
    });
    this.compression = 8;
    this.flag = f1419(p11325.level);
  }
  f1427.prototype.process = function (p11328, p11329) {
    try {
      this.d.push(p11328, p11329);
    } catch (e77) {
      this.ondata(e77, null, p11329);
    }
  };
  f1427.prototype.push = function (p11330, p11331) {
    vF72.prototype.push.call(this, p11330, p11331);
  };
  return f1427;
}();
var vF74 = function () {
  function f1428(p11332, p11333) {
    var vThis64 = this;
    if (!p11333) {
      p11333 = {};
    }
    vF72.call(this, p11332);
    this.d = new vF57(p11333, function (p11334, p11335, p11336) {
      vThis64.ondata(p11334, p11335, p11336);
    });
    this.compression = 8;
    this.flag = f1419(p11333.level);
    this.terminate = this.d.terminate;
  }
  f1428.prototype.process = function (p11337, p11338) {
    this.d.push(p11337, p11338);
  };
  f1428.prototype.push = function (p11339, p11340) {
    vF72.prototype.push.call(this, p11339, p11340);
  };
  return f1428;
}();
var vF75 = function () {
  function f1429(p11341) {
    this.ondata = p11341;
    this.u = [];
    this.d = 1;
  }
  f1429.prototype.add = function (p11342) {
    var vThis65 = this;
    if (this.d & 2) {
      throw "stream finished";
    }
    var vF1416 = f1416(p11342.filename);
    var v8334 = vF1416.length;
    var v8335 = p11342.comment;
    var v8336 = v8335 && f1416(v8335);
    var v8337 = v8334 != p11342.filename.length || v8336 && v8335.length != v8336.length;
    var v8338 = v8334 + f1423(p11342.extra) + 30;
    if (v8334 > 65535) {
      throw "filename too long";
    }
    var v8339 = new vUint8Array(v8338);
    f1424(v8339, 0, p11342, vF1416, v8337);
    var vA419 = [v8339];
    function f1430() {
      for (var vLN01367 = 0, vVA419 = vA419; vLN01367 < vVA419.length; vLN01367++) {
        var v8340 = vVA419[vLN01367];
        vThis65.ondata(null, v8340, false);
      }
      vA419 = [];
    }
    var v8341 = this.d;
    this.d = 0;
    var v8342 = this.u.length;
    var vF13572 = f1357(p11342, {
      f: vF1416,
      u: v8337,
      o: v8336,
      t: function () {
        if (p11342.terminate) {
          p11342.terminate();
        }
      },
      r: function () {
        f1430();
        if (v8341) {
          var v8343 = vThis65.u[v8342 + 1];
          if (v8343) {
            v8343.r();
          } else {
            vThis65.d = 1;
          }
        }
        v8341 = 1;
      }
    });
    var vLN01368 = 0;
    p11342.ondata = function (p11343, p11344, p11345) {
      if (p11343) {
        vThis65.ondata(p11343, p11344, p11345);
        vThis65.terminate();
      } else {
        vLN01368 += p11344.length;
        vA419.push(p11344);
        if (p11345) {
          var v8344 = new vUint8Array(16);
          f1375(v8344, 0, 134695760);
          f1375(v8344, 4, p11342.crc);
          f1375(v8344, 8, vLN01368);
          f1375(v8344, 12, p11342.size);
          vA419.push(v8344);
          vF13572.c = vLN01368;
          vF13572.b = v8338 + vLN01368 + 16;
          vF13572.crc = p11342.crc;
          vF13572.size = p11342.size;
          if (v8341) {
            vF13572.r();
          }
          v8341 = 1;
        } else if (v8341) {
          f1430();
        }
      }
    };
    this.u.push(vF13572);
  };
  f1429.prototype.end = function () {
    var vThis66 = this;
    if (this.d & 2) {
      if (this.d & 1) {
        throw "stream finishing";
      }
      throw "stream finished";
    }
    if (this.d) {
      this.e();
    } else {
      this.u.push({
        r: function () {
          if (!(vThis66.d & 1)) {
            return;
          }
          vThis66.u.splice(-1, 1);
          vThis66.e();
        },
        t: function () {}
      });
    }
    this.d = 3;
  };
  f1429.prototype.e = function () {
    var vLN01369 = 0;
    var vLN01370 = 0;
    var vLN01371 = 0;
    for (var vLN01372 = 0, v8345 = this.u; vLN01372 < v8345.length; vLN01372++) {
      var v8349 = v8345[vLN01372];
      vLN01371 += 46 + v8349.f.length + f1423(v8349.extra) + (v8349.o ? v8349.o.length : 0);
    }
    var v8347 = new vUint8Array(vLN01371 + 22);
    for (var vLN01373 = 0, v8348 = this.u; vLN01373 < v8348.length; vLN01373++) {
      var v8349 = v8348[vLN01373];
      f1424(v8347, vLN01369, v8349, v8349.f, v8349.u, v8349.c, vLN01370, v8349.o);
      vLN01369 += 46 + v8349.f.length + f1423(v8349.extra) + (v8349.o ? v8349.o.length : 0);
      vLN01370 += v8349.b;
    }
    f1425(v8347, vLN01369, this.u.length, vLN01371, vLN01370);
    this.ondata(null, v8347, true);
    this.d = 2;
  };
  f1429.prototype.terminate = function () {
    for (var vLN01374 = 0, v8350 = this.u; vLN01374 < v8350.length; vLN01374++) {
      var v8351 = v8350[vLN01374];
      v8351.t();
    }
    this.d = 2;
  };
  return f1429;
}();
function f1431(p11346, p11347, p11348) {
  if (!p11348) {
    p11348 = p11347;
    p11347 = {};
  }
  if (typeof p11348 != "function") {
    throw "no callback";
  }
  var vO243 = {};
  f1412(p11346, "", vO243, p11347);
  var v8352 = Object.keys(vO243);
  var v8353 = v8352.length;
  var vLN01375 = 0;
  var vLN01376 = 0;
  var vV8353 = v8353;
  var v8354 = new Array(v8353);
  var vA420 = [];
  function f1432() {
    for (var vLN01377 = 0; vLN01377 < vA420.length; ++vLN01377) {
      vA420[vLN01377]();
    }
  }
  function f1433() {
    var v8355 = new vUint8Array(vLN01376 + 22);
    var vVLN01375 = vLN01375;
    var v8356 = vLN01376 - vLN01375;
    vLN01376 = 0;
    for (var vLN01378 = 0; vLN01378 < vV8353; ++vLN01378) {
      var v8357 = v8354[vLN01378];
      try {
        var v8358 = v8357.c.length;
        f1424(v8355, vLN01376, v8357, v8357.f, v8357.u, v8358);
        var v8359 = 30 + v8357.f.length + f1423(v8357.extra);
        var v8360 = vLN01376 + v8359;
        v8355.set(v8357.c, v8360);
        f1424(v8355, vLN01375, v8357, v8357.f, v8357.u, v8358, vLN01376, v8357.m);
        vLN01375 += 16 + v8359 + (v8357.m ? v8357.m.length : 0);
        vLN01376 = v8360 + v8358;
      } catch (e78) {
        return p11348(e78, null);
      }
    }
    f1425(v8355, vLN01375, v8354.length, v8356, vVLN01375);
    p11348(null, v8355);
  }
  if (!v8353) {
    f1433();
  }
  function f1434(p11349) {
    var v8361 = v8352[p11349];
    var v8362 = vO243[v8361];
    var v8363 = v8362[0];
    var v8364 = v8362[1];
    var vF13543 = f1354();
    var v8365 = v8363.length;
    vF13543.p(v8363);
    var vF14162 = f1416(v8361);
    var v8366 = vF14162.length;
    var v8367 = v8364.comment;
    var v8368 = v8367 && f1416(v8367);
    var v8369 = v8368 && v8368.length;
    var vF14232 = f1423(v8364.extra);
    var v8370 = v8364.level == 0 ? 0 : 8;
    function f1435(p11350, p11351) {
      if (p11350) {
        f1432();
        p11348(p11350, null);
      } else {
        var v8371 = p11351.length;
        v8354[p11349] = f1357(v8364, {
          size: v8365,
          crc: vF13543.d(),
          c: p11351,
          f: vF14162,
          m: v8368,
          u: v8366 != v8361.length || v8368 && v8367.length != v8369,
          compression: v8370
        });
        vLN01375 += 30 + v8366 + vF14232 + v8371;
        vLN01376 += 76 + (v8366 + vF14232) * 2 + (v8369 || 0) + v8371;
        if (! --v8353) {
          f1433();
        }
      }
    }
    if (v8366 > 65535) {
      f1435("filename too long", null);
    }
    if (!v8370) {
      f1435(null, v8363);
    } else if (v8365 < 160000) {
      try {
        f1435(null, f1386(v8363, v8364));
      } catch (e79) {
        f1435(e79, null);
      }
    } else {
      vA420.push(f1385(v8363, v8364, f1435));
    }
  }
  for (var vLN01379 = 0; vLN01379 < vV8353; ++vLN01379) {
    f1434(vLN01379);
  }
  return f1432;
}
function f1436(p11352, p11353) {
  if (!p11353) {
    p11353 = {};
  }
  var vO244 = {};
  var vA421 = [];
  f1412(p11352, "", vO244, p11353);
  var vLN01380 = 0;
  var vLN01381 = 0;
  for (var v8372 in vO244) {
    var v8373 = vO244[v8372];
    var v8374 = v8373[0];
    var v8375 = v8373[1];
    var v8376 = v8375.level == 0 ? 0 : 8;
    var v8385 = f1416(v8372);
    var v8377 = v8385.length;
    var v8378 = v8375.comment;
    var v8379 = v8378 && f1416(v8378);
    var v8380 = v8379 && v8379.length;
    var vF14233 = f1423(v8375.extra);
    if (v8377 > 65535) {
      throw "filename too long";
    }
    var v8381 = v8376 ? f1386(v8374, v8375) : v8374;
    var v8382 = v8381.length;
    var vF13544 = f1354();
    vF13544.p(v8374);
    vA421.push(f1357(v8375, {
      size: v8374.length,
      crc: vF13544.d(),
      c: v8381,
      f: v8385,
      m: v8379,
      u: v8377 != v8372.length || v8379 && v8378.length != v8380,
      o: vLN01380,
      compression: v8376
    }));
    vLN01380 += 30 + v8377 + vF14233 + v8382;
    vLN01381 += 76 + (v8377 + vF14233) * 2 + (v8380 || 0) + v8382;
  }
  var v8383 = new vUint8Array(vLN01381 + 22);
  var vVLN01380 = vLN01380;
  var v8384 = vLN01381 - vLN01380;
  for (var vLN01382 = 0; vLN01382 < vA421.length; ++vLN01382) {
    var v8385 = vA421[vLN01382];
    f1424(v8383, v8385.o, v8385, v8385.f, v8385.u, v8385.c.length);
    var v8386 = 30 + v8385.f.length + f1423(v8385.extra);
    v8383.set(v8385.c, v8385.o + v8386);
    f1424(v8383, vLN01380, v8385, v8385.f, v8385.u, v8385.c.length, v8385.o, v8385.m);
    vLN01380 += 16 + v8386 + (v8385.m ? v8385.m.length : 0);
  }
  f1425(v8383, vLN01380, vA421.length, v8384, vVLN01380);
  return v8383;
}
var vF76 = function () {
  function f1437() {}
  f1437.prototype.push = function (p11354, p11355) {
    this.ondata(null, p11354, p11355);
  };
  f1437.compression = 0;
  return f1437;
}();
var vF77 = function () {
  function f1438() {
    var vThis67 = this;
    this.i = new vF58(function (p11356, p11357) {
      vThis67.ondata(null, p11356, p11357);
    });
  }
  f1438.prototype.push = function (p11358, p11359) {
    try {
      this.i.push(p11358, p11359);
    } catch (e80) {
      this.ondata(e80, p11358, p11359);
    }
  };
  f1438.compression = 8;
  return f1438;
}();
var vF78 = function () {
  function f1439(p11360, p11361) {
    var vThis68 = this;
    if (p11361 < 320000) {
      this.i = new vF58(function (p11362, p11363) {
        vThis68.ondata(null, p11362, p11363);
      });
    } else {
      this.i = new vF59(function (p11364, p11365, p11366) {
        vThis68.ondata(p11364, p11365, p11366);
      });
      this.terminate = this.i.terminate;
    }
  }
  f1439.prototype.push = function (p11367, p11368) {
    if (this.i.terminate) {
      p11367 = f1340(p11367, 0);
    }
    this.i.push(p11367, p11368);
  };
  f1439.compression = 8;
  return f1439;
}();
var vF79 = function () {
  function f1440(p11369) {
    this.onfile = p11369;
    this.k = [];
    this.o = {
      0: vF76
    };
    this.p = v8237;
  }
  f1440.prototype.push = function (p11370, p11371) {
    var vThis69 = this;
    if (!this.onfile) {
      throw "no callback";
    }
    if (!this.p) {
      throw "stream finished";
    }
    if (this.c > 0) {
      var v8387 = Math.min(this.c, p11370.length);
      var v8388 = p11370.subarray(0, v8387);
      this.c -= v8387;
      if (this.d) {
        this.d.push(v8388, !this.c);
      } else {
        this.k[0].push(v8388);
      }
      p11370 = p11370.subarray(v8387);
      if (p11370.length) {
        return this.push(p11370, p11371);
      }
    } else {
      var vLN01383 = 0;
      var vLN01384 = 0;
      var vUndefined5 = undefined;
      var vUndefined6 = undefined;
      if (!this.p.length) {
        vUndefined6 = p11370;
      } else if (!p11370.length) {
        vUndefined6 = this.p;
      } else {
        vUndefined6 = new vUint8Array(this.p.length + p11370.length);
        vUndefined6.set(this.p);
        vUndefined6.set(p11370, this.p.length);
      }
      var v8389 = vUndefined6.length;
      var v8390 = this.c;
      var v8391 = v8390 && this.d;
      function f1441() {
        var v8392;
        var vF13732 = f1373(vUndefined6, vLN01384);
        if (vF13732 == 67324752) {
          vLN01383 = 1;
          vUndefined5 = vLN01384;
          vThis70.d = null;
          vThis70.c = 0;
          var vF13722 = f1372(vUndefined6, vLN01384 + 6);
          var vF13723 = f1372(vUndefined6, vLN01384 + 8);
          var v8393 = vF13722 & 2048;
          var v8394 = vF13722 & 8;
          var vF13724 = f1372(vUndefined6, vLN01384 + 26);
          var vF13725 = f1372(vUndefined6, vLN01384 + 28);
          if (v8389 > vLN01384 + 30 + vF13724 + vF13725) {
            var vA422 = [];
            vThis70.k.unshift(vA422);
            vLN01383 = 2;
            var vF13733 = f1373(vUndefined6, vLN01384 + 18);
            var vF13734 = f1373(vUndefined6, vLN01384 + 22);
            var vF14182 = f1418(vUndefined6.subarray(vLN01384 + 30, vLN01384 += 30 + vF13724), !v8393);
            if (vF13733 == 4294967295) {
              v8392 = v8394 ? [-2] : f1422(vUndefined6, vLN01384);
              vF13733 = v8392[0];
              vF13734 = v8392[1];
            } else if (v8394) {
              vF13733 = -1;
            }
            vLN01384 += vF13725;
            vThis70.c = vF13733;
            var v8395;
            var vO245 = {
              name: vF14182,
              compression: vF13723,
              start: function () {
                if (!vO245.ondata) {
                  throw "no callback";
                }
                if (!vF13733) {
                  vO245.ondata(null, v8237, true);
                } else {
                  var v8396 = vThis69.o[vF13723];
                  if (!v8396) {
                    throw "unknown compression type " + vF13723;
                  }
                  v8395 = vF13733 < 0 ? new v8396(vF14182) : new v8396(vF14182, vF13733, vF13734);
                  v8395.ondata = function (p11372, p11373, p11374) {
                    vO245.ondata(p11372, p11373, p11374);
                  };
                  for (var vLN01385 = 0, vVA422 = vA422; vLN01385 < vVA422.length; vLN01385++) {
                    var v8397 = vVA422[vLN01385];
                    v8395.push(v8397, false);
                  }
                  if (vThis69.k[0] == vA422 && vThis69.c) {
                    vThis69.d = v8395;
                  } else {
                    v8395.push(v8237, true);
                  }
                }
              },
              terminate: function () {
                if (v8395 && v8395.terminate) {
                  v8395.terminate();
                }
              }
            };
            if (vF13733 >= 0) {
              vO245.size = vF13733;
              vO245.originalSize = vF13734;
            }
            vThis70.onfile(vO245);
          }
          return "break";
        } else if (v8390) {
          if (vF13732 == 134695760) {
            vUndefined5 = vLN01384 += 12 + (v8390 == -2 && 8);
            vLN01383 = 3;
            vThis70.c = 0;
            return "break";
          } else if (vF13732 == 33639248) {
            vUndefined5 = vLN01384 -= 4;
            vLN01383 = 3;
            vThis70.c = 0;
            return "break";
          }
        }
      }
      var vThis70 = this;
      for (; vLN01384 < v8389 - 4; ++vLN01384) {
        var vF1441 = f1441();
        if (vF1441 === "break") {
          break;
        }
      }
      this.p = v8237;
      if (v8390 < 0) {
        var v8398 = vLN01383 ? vUndefined6.subarray(0, vUndefined5 - 12 - (v8390 == -2 && 8) - (f1373(vUndefined6, vUndefined5 - 16) == 134695760 && 4)) : vUndefined6.subarray(0, vLN01384);
        if (v8391) {
          v8391.push(v8398, !!vLN01383);
        } else {
          this.k[+(vLN01383 == 2)].push(v8398);
        }
      }
      if (vLN01383 & 2) {
        return this.push(vUndefined6.subarray(vLN01384), p11371);
      }
      this.p = vUndefined6.subarray(vLN01384);
    }
    if (p11371) {
      if (this.c) {
        throw "invalid zip file";
      }
      this.p = null;
    }
  };
  f1440.prototype.register = function (p11375) {
    this.o[p11375.compression] = p11375;
  };
  return f1440;
}();
function f1442(p11376, p11377) {
  if (typeof p11377 != "function") {
    throw "no callback";
  }
  var vA423 = [];
  function f1443() {
    for (var vLN01386 = 0; vLN01386 < vA423.length; ++vLN01386) {
      vA423[vLN01386]();
    }
  }
  var vO246 = {};
  var v8399 = p11376.length - 22;
  for (; f1373(p11376, v8399) != 101010256; --v8399) {
    if (!v8399 || p11376.length - v8399 > 65558) {
      p11377("invalid zip file", null);
      return;
    }
  }
  ;
  var vF13726 = f1372(p11376, v8399 + 8);
  if (!vF13726) {
    p11377(null, {});
  }
  var vVF13726 = vF13726;
  var vF13735 = f1373(p11376, v8399 + 16);
  var v8400 = vF13735 == 4294967295;
  if (v8400) {
    v8399 = f1373(p11376, v8399 - 12);
    if (f1373(p11376, v8399) != 101075792) {
      p11377("invalid zip file", null);
      return;
    }
    vVF13726 = vF13726 = f1373(p11376, v8399 + 32);
    vF13735 = f1373(p11376, v8399 + 48);
  }
  function f1444(p11378) {
    var vF1421 = f1421(p11376, vF13735, v8400);
    var v8401 = vF1421[0];
    var v8402 = vF1421[1];
    var v8403 = vF1421[2];
    var v8404 = vF1421[3];
    var v8405 = vF1421[4];
    var v8406 = vF1421[5];
    var vF1420 = f1420(p11376, v8406);
    vF13735 = v8405;
    function f1445(p11379, p11380) {
      if (p11379) {
        f1443();
        p11377(p11379, null);
      } else {
        vO246[v8404] = p11380;
        if (! --vF13726) {
          p11377(null, vO246);
        }
      }
    }
    if (!v8401) {
      f1445(null, f1340(p11376, vF1420, vF1420 + v8402));
    } else if (v8401 == 8) {
      var v8407 = p11376.subarray(vF1420, vF1420 + v8402);
      if (v8402 < 320000) {
        try {
          f1445(null, f1390(v8407, new vUint8Array(v8403)));
        } catch (e81) {
          f1445(e81, null);
        }
      } else {
        vA423.push(f1389(v8407, {
          size: v8403
        }, f1445));
      }
    } else {
      f1445("unknown compression type " + v8401, null);
    }
  }
  for (var vLN01387 = 0; vLN01387 < vVF13726; ++vLN01387) {
    f1444(vLN01387);
  }
  return f1443;
}
function f1446(p11381) {
  var vO247 = {};
  var v8408 = p11381.length - 22;
  for (; f1373(p11381, v8408) != 101010256; --v8408) {
    if (!v8408 || p11381.length - v8408 > 65558) {
      throw "invalid zip file";
    }
  }
  ;
  var vF13727 = f1372(p11381, v8408 + 8);
  if (!vF13727) {
    return {};
  }
  var vF13736 = f1373(p11381, v8408 + 16);
  var v8409 = vF13736 == 4294967295;
  if (v8409) {
    v8408 = f1373(p11381, v8408 - 12);
    if (f1373(p11381, v8408) != 101075792) {
      throw "invalid zip file";
    }
    vF13727 = f1373(p11381, v8408 + 32);
    vF13736 = f1373(p11381, v8408 + 48);
  }
  for (var vLN01388 = 0; vLN01388 < vF13727; ++vLN01388) {
    var vF14212 = f1421(p11381, vF13736, v8409);
    var v8410 = vF14212[0];
    var v8411 = vF14212[1];
    var v8412 = vF14212[2];
    var v8413 = vF14212[3];
    var v8414 = vF14212[4];
    var v8415 = vF14212[5];
    var vF14202 = f1420(p11381, v8415);
    vF13736 = v8414;
    if (!v8410) {
      vO247[v8413] = f1340(p11381, vF14202, vF14202 + v8411);
    } else if (v8410 == 8) {
      vO247[v8413] = f1390(p11381.subarray(vF14202, vF14202 + v8411), new vUint8Array(v8412));
    } else {
      throw "unknown compression type " + v8410;
    }
  }
  return vO247;
}
function f1447(p11382, p11383, p11384) {
  const v8416 = p11384.length - p11382 - 1;
  if (p11383 >= p11384[v8416]) {
    return v8416 - 1;
  }
  if (p11383 <= p11384[p11382]) {
    return p11382;
  }
  let vP11382 = p11382;
  let vV8416 = v8416;
  let v8417 = Math.floor((vP11382 + vV8416) / 2);
  while (p11383 < p11384[v8417] || p11383 >= p11384[v8417 + 1]) {
    if (p11383 < p11384[v8417]) {
      vV8416 = v8417;
    } else {
      vP11382 = v8417;
    }
    v8417 = Math.floor((vP11382 + vV8416) / 2);
  }
  return v8417;
}
function f1448(p11385, p11386, p11387, p11388) {
  const vA424 = [];
  const vA425 = [];
  const vA426 = [];
  vA424[0] = 1;
  for (let vLN1123 = 1; vLN1123 <= p11387; ++vLN1123) {
    vA425[vLN1123] = p11386 - p11388[p11385 + 1 - vLN1123];
    vA426[vLN1123] = p11388[p11385 + vLN1123] - p11386;
    let vLN01389 = 0;
    for (let vLN01390 = 0; vLN01390 < vLN1123; ++vLN01390) {
      const v8418 = vA426[vLN01390 + 1];
      const v8419 = vA425[vLN1123 - vLN01390];
      const v8420 = vA424[vLN01390] / (v8418 + v8419);
      vA424[vLN01390] = vLN01389 + v8418 * v8420;
      vLN01389 = v8419 * v8420;
    }
    vA424[vLN1123] = vLN01389;
  }
  return vA424;
}
function f1449(p11389, p11390, p11391, p11392) {
  const vF1447 = f1447(p11389, p11392, p11390);
  const vF1448 = f1448(vF1447, p11392, p11389, p11390);
  const v8421 = new THREE.Vector4(0, 0, 0, 0);
  for (let vLN01391 = 0; vLN01391 <= p11389; ++vLN01391) {
    const v8422 = p11391[vF1447 - p11389 + vLN01391];
    const v8423 = vF1448[vLN01391];
    const v8424 = v8422.w * v8423;
    v8421.x += v8422.x * v8424;
    v8421.y += v8422.y * v8424;
    v8421.z += v8422.z * v8424;
    v8421.w += v8422.w * v8423;
  }
  return v8421;
}
function f1450(p11393, p11394, p11395, p11396, p11397) {
  const vA427 = [];
  for (let vLN01392 = 0; vLN01392 <= p11395; ++vLN01392) {
    vA427[vLN01392] = 0;
  }
  const vA428 = [];
  for (let vLN01393 = 0; vLN01393 <= p11396; ++vLN01393) {
    vA428[vLN01393] = vA427.slice(0);
  }
  const vA429 = [];
  for (let vLN01394 = 0; vLN01394 <= p11395; ++vLN01394) {
    vA429[vLN01394] = vA427.slice(0);
  }
  vA429[0][0] = 1;
  const v8425 = vA427.slice(0);
  const v8426 = vA427.slice(0);
  for (let vLN1124 = 1; vLN1124 <= p11395; ++vLN1124) {
    v8425[vLN1124] = p11394 - p11397[p11393 + 1 - vLN1124];
    v8426[vLN1124] = p11397[p11393 + vLN1124] - p11394;
    let vLN01395 = 0;
    for (let vLN01396 = 0; vLN01396 < vLN1124; ++vLN01396) {
      const v8427 = v8426[vLN01396 + 1];
      const v8428 = v8425[vLN1124 - vLN01396];
      vA429[vLN1124][vLN01396] = v8427 + v8428;
      const v8429 = vA429[vLN01396][vLN1124 - 1] / vA429[vLN1124][vLN01396];
      vA429[vLN01396][vLN1124] = vLN01395 + v8427 * v8429;
      vLN01395 = v8428 * v8429;
    }
    vA429[vLN1124][vLN1124] = vLN01395;
  }
  for (let vLN01397 = 0; vLN01397 <= p11395; ++vLN01397) {
    vA428[0][vLN01397] = vA429[vLN01397][p11395];
  }
  for (let vLN01398 = 0; vLN01398 <= p11395; ++vLN01398) {
    let vLN01399 = 0;
    let vLN1125 = 1;
    const vA430 = [];
    for (let vLN01400 = 0; vLN01400 <= p11395; ++vLN01400) {
      vA430[vLN01400] = vA427.slice(0);
    }
    vA430[0][0] = 1;
    for (let vLN1126 = 1; vLN1126 <= p11396; ++vLN1126) {
      let vLN01401 = 0;
      const v8430 = vLN01398 - vLN1126;
      const v8431 = p11395 - vLN1126;
      if (vLN01398 >= vLN1126) {
        vA430[vLN1125][0] = vA430[vLN01399][0] / vA429[v8431 + 1][v8430];
        vLN01401 = vA430[vLN1125][0] * vA429[v8430][v8431];
      }
      const v8432 = v8430 >= -1 ? 1 : -v8430;
      const v8433 = vLN01398 - 1 <= v8431 ? vLN1126 - 1 : p11395 - vLN01398;
      for (let vV8432 = v8432; vV8432 <= v8433; ++vV8432) {
        vA430[vLN1125][vV8432] = (vA430[vLN01399][vV8432] - vA430[vLN01399][vV8432 - 1]) / vA429[v8431 + 1][v8430 + vV8432];
        vLN01401 += vA430[vLN1125][vV8432] * vA429[v8430 + vV8432][v8431];
      }
      if (vLN01398 <= v8431) {
        vA430[vLN1125][vLN1126] = -vA430[vLN01399][vLN1126 - 1] / vA429[v8431 + 1][vLN01398];
        vLN01401 += vA430[vLN1125][vLN1126] * vA429[vLN01398][v8431];
      }
      vA428[vLN1126][vLN01398] = vLN01401;
      const vVLN01399 = vLN01399;
      vLN01399 = vLN1125;
      vLN1125 = vVLN01399;
    }
  }
  let vP11395 = p11395;
  for (let vLN1127 = 1; vLN1127 <= p11396; ++vLN1127) {
    for (let vLN01402 = 0; vLN01402 <= p11395; ++vLN01402) {
      vA428[vLN1127][vLN01402] *= vP11395;
    }
    vP11395 *= p11395 - vLN1127;
  }
  return vA428;
}
function f1451(p11398, p11399, p11400, p11401, p11402) {
  const v8434 = p11402 < p11398 ? p11402 : p11398;
  const vA431 = [];
  const vF14472 = f1447(p11398, p11401, p11399);
  const vF1450 = f1450(vF14472, p11401, p11398, v8434, p11399);
  const vA432 = [];
  for (let vLN01403 = 0; vLN01403 < p11400.length; ++vLN01403) {
    const v8435 = p11400[vLN01403].clone();
    const v8436 = v8435.w;
    v8435.x *= v8436;
    v8435.y *= v8436;
    v8435.z *= v8436;
    vA432[vLN01403] = v8435;
  }
  for (let vLN01404 = 0; vLN01404 <= v8434; ++vLN01404) {
    const v8437 = vA432[vF14472 - p11398].clone().multiplyScalar(vF1450[vLN01404][0]);
    for (let vLN1128 = 1; vLN1128 <= p11398; ++vLN1128) {
      v8437.add(vA432[vF14472 - p11398 + vLN1128].clone().multiplyScalar(vF1450[vLN01404][vLN1128]));
    }
    vA431[vLN01404] = v8437;
  }
  for (let v8438 = v8434 + 1; v8438 <= p11402 + 1; ++v8438) {
    vA431[v8438] = new THREE.Vector4(0, 0, 0);
  }
  return vA431;
}
function f1452(p11403, p11404) {
  let vLN1129 = 1;
  for (let vLN220 = 2; vLN220 <= p11403; ++vLN220) {
    vLN1129 *= vLN220;
  }
  let vLN1130 = 1;
  for (let vLN221 = 2; vLN221 <= p11404; ++vLN221) {
    vLN1130 *= vLN221;
  }
  for (let vLN222 = 2; vLN222 <= p11403 - p11404; ++vLN222) {
    vLN1130 *= vLN222;
  }
  return vLN1129 / vLN1130;
}
function f1453(p11405) {
  const v8439 = p11405.length;
  const vA433 = [];
  const vA434 = [];
  for (let vLN01405 = 0; vLN01405 < v8439; ++vLN01405) {
    const v8440 = p11405[vLN01405];
    vA433[vLN01405] = new THREE.Vector3(v8440.x, v8440.y, v8440.z);
    vA434[vLN01405] = v8440.w;
  }
  const vA435 = [];
  for (let vLN01406 = 0; vLN01406 < v8439; ++vLN01406) {
    const v8441 = vA433[vLN01406].clone();
    for (let vLN1131 = 1; vLN1131 <= vLN01406; ++vLN1131) {
      v8441.sub(vA435[vLN01406 - vLN1131].clone().multiplyScalar(f1452(vLN01406, vLN1131) * vA434[vLN1131]));
    }
    vA435[vLN01406] = v8441.divideScalar(vA434[0]);
  }
  return vA435;
}
function f1454(p11406, p11407, p11408, p11409, p11410) {
  const vF1451 = f1451(p11406, p11407, p11408, p11409, p11410);
  return f1453(vF1451);
}
function f1455(p11411, p11412, p11413, p11414, p11415, p11416, p11417, p11418) {
  const vF14473 = f1447(p11411, p11416, p11413);
  const vF14474 = f1447(p11412, p11417, p11414);
  const vF14482 = f1448(vF14473, p11416, p11411, p11413);
  const vF14483 = f1448(vF14474, p11417, p11412, p11414);
  const vA436 = [];
  for (let vLN01407 = 0; vLN01407 <= p11412; ++vLN01407) {
    vA436[vLN01407] = new THREE.Vector4(0, 0, 0, 0);
    for (let vLN01408 = 0; vLN01408 <= p11411; ++vLN01408) {
      const v8442 = p11415[vF14473 - p11411 + vLN01408][vF14474 - p11412 + vLN01407].clone();
      const v8443 = v8442.w;
      v8442.x *= v8443;
      v8442.y *= v8443;
      v8442.z *= v8443;
      vA436[vLN01407].add(v8442.multiplyScalar(vF14482[vLN01408]));
    }
  }
  const v8444 = new THREE.Vector4(0, 0, 0, 0);
  for (let vLN01409 = 0; vLN01409 <= p11412; ++vLN01409) {
    v8444.add(vA436[vLN01409].multiplyScalar(vF14483[vLN01409]));
  }
  v8444.divideScalar(v8444.w);
  p11418.set(v8444.x, v8444.y, v8444.z);
}
class C246 extends THREE.Curve {
  constructor(p11419, p11420, p11421, p11422, p11423) {
    super();
    this.degree = p11419;
    this.knots = p11420;
    this.controlPoints = [];
    this.startKnot = p11422 || 0;
    this.endKnot = p11423 || this.knots.length - 1;
    for (let vLN01410 = 0; vLN01410 < p11421.length; ++vLN01410) {
      const v8445 = p11421[vLN01410];
      this.controlPoints[vLN01410] = new THREE.Vector4(v8445.x, v8445.y, v8445.z, v8445.w);
    }
  }
  getPoint(p11424, p11425 = new THREE.Vector3()) {
    const vP11425 = p11425;
    const v8446 = this.knots[this.startKnot] + p11424 * (this.knots[this.endKnot] - this.knots[this.startKnot]);
    const vF1449 = f1449(this.degree, this.knots, this.controlPoints, v8446);
    if (vF1449.w !== 1) {
      vF1449.divideScalar(vF1449.w);
    }
    return vP11425.set(vF1449.x, vF1449.y, vF1449.z);
  }
  getTangent(p11426, p11427 = new THREE.Vector3()) {
    const vP11427 = p11427;
    const v8447 = this.knots[0] + p11426 * (this.knots[this.knots.length - 1] - this.knots[0]);
    const vF1454 = f1454(this.degree, this.knots, this.controlPoints, v8447, 1);
    vP11427.copy(vF1454[1]).normalize();
    return vP11427;
  }
}
let v8448;
let v8449;
let v8450;
export class FBXLoader extends THREE.Loader {
  constructor(p11428) {
    super(p11428);
  }
  load(p11429, p11430, p11431, p11432) {
    const vThis71 = this;
    const v8451 = vThis71.path === "" ? THREE.LoaderUtils.extractUrlBase(p11429) : vThis71.path;
    const v8452 = new THREE.FileLoader(this.manager);
    v8452.setPath(vThis71.path);
    v8452.setResponseType("arraybuffer");
    v8452.setRequestHeader(vThis71.requestHeader);
    v8452.setWithCredentials(vThis71.withCredentials);
    v8452.load(p11429, function (p11433) {
      try {
        p11430(vThis71.parse(p11433, v8451));
      } catch (e82) {
        if (p11432) {
          p11432(e82);
        } else {
          console.error(e82);
        }
        vThis71.manager.itemError(p11429);
      }
    }, p11431, p11432);
  }
  parse(p11434, p11435) {
    if (f1456(p11434)) {
      v8448 = new C252().parse(p11434);
    } else {
      const vIiii8 = f1465(p11434);
      if (!f1457(vIiii8)) {
        throw new Error("THREE.FBXLoader: Unknown format.");
      }
      if (f1459(vIiii8) < 7000) {
        throw new Error("THREE.FBXLoader: FBX version not supported, FileVersion: " + f1459(vIiii8));
      }
      v8448 = new C251().parse(vIiii8);
    }
    const v8453 = new THREE.TextureLoader(this.manager).setPath(this.resourcePath || p11435).setCrossOrigin(this.crossOrigin);
    return new C248(v8453, this.manager).parse(v8448);
  }
}
class C248 {
  constructor(p11436, p11437) {
    this.textureLoader = p11436;
    this.manager = p11437;
  }
  parse() {
    v8449 = this.parseConnections();
    const v8454 = this.parseImages();
    const v8455 = this.parseTextures(v8454);
    const v8456 = this.parseMaterials(v8455);
    const v8457 = this.parseDeformers();
    const v8458 = new C249().parse(v8457);
    this.parseScene(v8457, v8458, v8456);
    return v8450;
  }
  parseConnections() {
    const v8459 = new Map();
    if ("Connections" in v8448) {
      const v8460 = v8448.Connections.connections;
      v8460.forEach(function (p11438) {
        const v8461 = p11438[0];
        const v8462 = p11438[1];
        const v8463 = p11438[2];
        if (!v8459.has(v8461)) {
          v8459.set(v8461, {
            parents: [],
            children: []
          });
        }
        const vO248 = {
          ID: v8462,
          relationship: v8463
        };
        v8459.get(v8461).parents.push(vO248);
        if (!v8459.has(v8462)) {
          v8459.set(v8462, {
            parents: [],
            children: []
          });
        }
        const vO249 = {
          ID: v8461,
          relationship: v8463
        };
        v8459.get(v8462).children.push(vO249);
      });
    }
    return v8459;
  }
  parseImages() {
    const vO250 = {};
    const vO251 = {};
    if ("Video" in v8448.Objects) {
      const v8464 = v8448.Objects.Video;
      for (const v8465 in v8464) {
        const v8466 = v8464[v8465];
        const vParseInt22 = parseInt(v8465);
        vO250[vParseInt22] = v8466.RelativeFilename || v8466.Filename;
        if ("Content" in v8466) {
          const v8467 = v8466.Content instanceof ArrayBuffer && v8466.Content.byteLength > 0;
          const v8468 = typeof v8466.Content === "string" && v8466.Content !== "";
          if (v8467 || v8468) {
            const v8469 = this.parseImage(v8464[v8465]);
            vO251[v8466.RelativeFilename || v8466.Filename] = v8469;
          }
        }
      }
    }
    for (const v8470 in vO250) {
      const v8471 = vO250[v8470];
      if (vO251[v8471] !== undefined) {
        vO250[v8470] = vO251[v8471];
      } else {
        vO250[v8470] = vO250[v8470].split("\\").pop();
      }
    }
    return vO250;
  }
  parseImage(p11439) {
    const v8472 = p11439.Content;
    const v8473 = p11439.RelativeFilename || p11439.Filename;
    const v8474 = v8473.slice(v8473.lastIndexOf(".") + 1).toLowerCase();
    let v8475;
    switch (v8474) {
      case "bmp":
        v8475 = "image/bmp";
        break;
      case "jpg":
      case "jpeg":
        v8475 = "image/jpeg";
        break;
      case "png":
        v8475 = "image/png";
        break;
      case "tif":
        v8475 = "image/tiff";
        break;
      case "tga":
        if (this.manager.getHandler(".tga") === null) {
          console.warn("FBXLoader: TGA loader not found, skipping ", v8473);
        }
        v8475 = "image/tga";
        break;
      default:
        console.warn("FBXLoader: Image type \"" + v8474 + "\" is not supported.");
        return;
    }
    if (typeof v8472 === "string") {
      return "data:" + v8475 + ";base64," + v8472;
    } else {
      const v8476 = new Uint8Array(v8472);
      return window.URL.createObjectURL(new Blob([v8476], {
        type: v8475
      }));
    }
  }
  parseTextures(p11440) {
    const v8477 = new Map();
    if ("Texture" in v8448.Objects) {
      const v8478 = v8448.Objects.Texture;
      for (const v8479 in v8478) {
        const v8480 = this.parseTexture(v8478[v8479], p11440);
        v8477.set(parseInt(v8479), v8480);
      }
    }
    return v8477;
  }
  parseTexture(p11441, p11442) {
    const v8481 = this.loadTexture(p11441, p11442);
    v8481.ID = p11441.id;
    v8481.name = p11441.attrName;
    const v8482 = p11441.WrapModeU;
    const v8483 = p11441.WrapModeV;
    const v8484 = v8482 !== undefined ? v8482.value : 0;
    const v8485 = v8483 !== undefined ? v8483.value : 0;
    v8481.wrapS = v8484 === 0 ? THREE.RepeatWrapping : THREE.ClampToEdgeWrapping;
    v8481.wrapT = v8485 === 0 ? THREE.RepeatWrapping : THREE.ClampToEdgeWrapping;
    if ("Scaling" in p11441) {
      const v8486 = p11441.Scaling.value;
      v8481.repeat.x = v8486[0];
      v8481.repeat.y = v8486[1];
    }
    if ("Translation" in p11441) {
      const v8487 = p11441.Translation.value;
      v8481.offset.x = v8487[0];
      v8481.offset.y = v8487[1];
    }
    return v8481;
  }
  loadTexture(p11443, p11444) {
    let v8488;
    const v8489 = this.textureLoader.path;
    const v8490 = v8449.get(p11443.id).children;
    if (v8490 !== undefined && v8490.length > 0 && p11444[v8490[0].ID] !== undefined) {
      v8488 = p11444[v8490[0].ID];
      if (v8488.indexOf("blob:") === 0 || v8488.indexOf("data:") === 0) {
        this.textureLoader.setPath(undefined);
      }
    }
    let v8491;
    const v8492 = p11443.FileName.slice(-3).toLowerCase();
    if (v8492 === "tga") {
      const v8493 = this.manager.getHandler(".tga");
      if (v8493 === null) {
        console.warn("FBXLoader: TGA loader not found, creating placeholder texture for", p11443.RelativeFilename);
        v8491 = new THREE.Texture();
      } else {
        v8493.setPath(this.textureLoader.path);
        v8491 = v8493.load(v8488);
      }
    } else if (v8492 === "psd") {
      console.warn("FBXLoader: PSD textures are not supported, creating placeholder texture for", p11443.RelativeFilename);
      v8491 = new THREE.Texture();
    } else {
      v8491 = this.textureLoader.load(v8488);
    }
    this.textureLoader.setPath(v8489);
    return v8491;
  }
  parseMaterials(p11445) {
    const v8494 = new Map();
    if ("Material" in v8448.Objects) {
      const v8495 = v8448.Objects.Material;
      for (const v8496 in v8495) {
        const v8497 = this.parseMaterial(v8495[v8496], p11445);
        if (v8497 !== null) {
          v8494.set(parseInt(v8496), v8497);
        }
      }
    }
    return v8494;
  }
  parseMaterial(p11446, p11447) {
    const v8498 = p11446.id;
    const v8499 = p11446.attrName;
    let v8500 = p11446.ShadingModel;
    if (typeof v8500 === "object") {
      v8500 = v8500.value;
    }
    if (!v8449.has(v8498)) {
      return null;
    }
    const v8501 = this.parseParameters(p11446, p11447, v8498);
    let v8502;
    switch (v8500.toLowerCase()) {
      case "phong":
        v8502 = new THREE.MeshPhongMaterial();
        break;
      case "lambert":
        v8502 = new THREE.MeshLambertMaterial();
        break;
      default:
        console.warn("THREE.FBXLoader: unknown material type \"%s\". Defaulting to MeshPhongMaterial.", v8500);
        v8502 = new THREE.MeshPhongMaterial();
        break;
    }
    v8502.setValues(v8501);
    v8502.name = v8499;
    return v8502;
  }
  parseParameters(p11448, p11449, p11450) {
    const vO252 = {};
    if (p11448.BumpFactor) {
      vO252.bumpScale = p11448.BumpFactor.value;
    }
    if (p11448.Diffuse) {
      vO252.color = new THREE.Color().fromArray(p11448.Diffuse.value);
    } else if (p11448.DiffuseColor && (p11448.DiffuseColor.type === "Color" || p11448.DiffuseColor.type === "ColorRGB")) {
      vO252.color = new THREE.Color().fromArray(p11448.DiffuseColor.value);
    }
    if (p11448.DisplacementFactor) {
      vO252.displacementScale = p11448.DisplacementFactor.value;
    }
    if (p11448.Emissive) {
      vO252.emissive = new THREE.Color().fromArray(p11448.Emissive.value);
    } else if (p11448.EmissiveColor && (p11448.EmissiveColor.type === "Color" || p11448.EmissiveColor.type === "ColorRGB")) {
      vO252.emissive = new THREE.Color().fromArray(p11448.EmissiveColor.value);
    }
    if (p11448.EmissiveFactor) {
      vO252.emissiveIntensity = parseFloat(p11448.EmissiveFactor.value);
    }
    if (p11448.Opacity) {
      vO252.opacity = parseFloat(p11448.Opacity.value);
    }
    if (vO252.opacity < 1) {
      vO252.transparent = true;
    }
    if (p11448.ReflectionFactor) {
      vO252.reflectivity = p11448.ReflectionFactor.value;
    }
    if (p11448.Shininess) {
      vO252.shininess = p11448.Shininess.value;
    }
    if (p11448.Specular) {
      vO252.specular = new THREE.Color().fromArray(p11448.Specular.value);
    } else if (p11448.SpecularColor && p11448.SpecularColor.type === "Color") {
      vO252.specular = new THREE.Color().fromArray(p11448.SpecularColor.value);
    }
    const vThis72 = this;
    v8449.get(p11450).children.forEach(function (p11451) {
      const v8503 = p11451.relationship;
      switch (v8503) {
        case "Bump":
          vO252.bumpMap = vThis72.getTexture(p11449, p11451.ID);
          break;
        case "Maya|TEX_ao_map":
          vO252.aoMap = vThis72.getTexture(p11449, p11451.ID);
          break;
        case "DiffuseColor":
        case "Maya|TEX_color_map":
          vO252.map = vThis72.getTexture(p11449, p11451.ID);
          if (vO252.map !== undefined) {
            vO252.map.encoding = THREE.sRGBEncoding;
          }
          break;
        case "DisplacementColor":
          vO252.displacementMap = vThis72.getTexture(p11449, p11451.ID);
          break;
        case "EmissiveColor":
          vO252.emissiveMap = vThis72.getTexture(p11449, p11451.ID);
          if (vO252.emissiveMap !== undefined) {
            vO252.emissiveMap.encoding = THREE.sRGBEncoding;
          }
          break;
        case "NormalMap":
        case "Maya|TEX_normal_map":
          vO252.normalMap = vThis72.getTexture(p11449, p11451.ID);
          break;
        case "ReflectionColor":
          vO252.envMap = vThis72.getTexture(p11449, p11451.ID);
          if (vO252.envMap !== undefined) {
            vO252.envMap.mapping = THREE.EquirectangularReflectionMapping;
            vO252.envMap.encoding = THREE.sRGBEncoding;
          }
          break;
        case "SpecularColor":
          vO252.specularMap = vThis72.getTexture(p11449, p11451.ID);
          if (vO252.specularMap !== undefined) {
            vO252.specularMap.encoding = THREE.sRGBEncoding;
          }
          break;
        case "TransparentColor":
        case "TransparencyFactor":
          vO252.alphaMap = vThis72.getTexture(p11449, p11451.ID);
          vO252.transparent = true;
          break;
        case "AmbientColor":
        case "ShininessExponent":
        case "SpecularFactor":
        case "VectorDisplacementColor":
        default:
          console.warn("THREE.FBXLoader: %s map is not supported in three.js, skipping texture.", v8503);
          break;
      }
    });
    return vO252;
  }
  getTexture(p11452, p11453) {
    if ("LayeredTexture" in v8448.Objects && p11453 in v8448.Objects.LayeredTexture) {
      console.warn("THREE.FBXLoader: layered textures are not supported in three.js. Discarding all but first layer.");
      p11453 = v8449.get(p11453).children[0].ID;
    }
    return p11452.get(p11453);
  }
  parseDeformers() {
    const vO253 = {};
    const vO254 = {};
    if ("Deformer" in v8448.Objects) {
      const v8504 = v8448.Objects.Deformer;
      for (const v8505 in v8504) {
        const v8506 = v8504[v8505];
        const v8507 = v8449.get(parseInt(v8505));
        if (v8506.attrType === "Skin") {
          const v8508 = this.parseSkeleton(v8507, v8504);
          v8508.ID = v8505;
          if (v8507.parents.length > 1) {
            console.warn("THREE.FBXLoader: skeleton attached to more than one geometry is not supported.");
          }
          v8508.geometryID = v8507.parents[0].ID;
          vO253[v8505] = v8508;
        } else if (v8506.attrType === "BlendShape") {
          const vO255 = {
            id: v8505
          };
          vO255.rawTargets = this.parseMorphTargets(v8507, v8504);
          vO255.id = v8505;
          if (v8507.parents.length > 1) {
            console.warn("THREE.FBXLoader: morph target attached to more than one geometry is not supported.");
          }
          vO254[v8505] = vO255;
        }
      }
    }
    return {
      skeletons: vO253,
      morphTargets: vO254
    };
  }
  parseSkeleton(p11454, p11455) {
    const vA437 = [];
    p11454.children.forEach(function (p11456) {
      const v8509 = p11455[p11456.ID];
      if (v8509.attrType !== "Cluster") {
        return;
      }
      const vO256 = {
        ID: p11456.ID,
        indices: [],
        weights: [],
        transformLink: new THREE.Matrix4().fromArray(v8509.TransformLink.a)
      };
      if ("Indexes" in v8509) {
        vO256.indices = v8509.Indexes.a;
        vO256.weights = v8509.Weights.a;
      }
      vA437.push(vO256);
    });
    return {
      rawBones: vA437,
      bones: []
    };
  }
  parseMorphTargets(p11457, p11458) {
    const vA438 = [];
    for (let vLN01411 = 0; vLN01411 < p11457.children.length; vLN01411++) {
      const v8510 = p11457.children[vLN01411];
      const v8511 = p11458[v8510.ID];
      const vO257 = {
        name: v8511.attrName,
        initialWeight: v8511.DeformPercent,
        id: v8511.id,
        fullWeights: v8511.FullWeights.a
      };
      if (v8511.attrType !== "BlendShapeChannel") {
        return;
      }
      vO257.geoID = v8449.get(parseInt(v8510.ID)).children.filter(function (p11459) {
        return p11459.relationship === undefined;
      })[0].ID;
      vA438.push(vO257);
    }
    return vA438;
  }
  parseScene(p11460, p11461, p11462) {
    v8450 = new THREE.Group();
    const v8512 = this.parseModels(p11460.skeletons, p11461, p11462);
    const v8513 = v8448.Objects.Model;
    const vThis73 = this;
    v8512.forEach(function (p11463) {
      const v8514 = v8513[p11463.ID];
      vThis73.setLookAtProperties(p11463, v8514);
      const v8515 = v8449.get(p11463.ID).parents;
      v8515.forEach(function (p11464) {
        const v8516 = v8512.get(p11464.ID);
        if (v8516 !== undefined) {
          v8516.add(p11463);
        }
      });
      if (p11463.parent === null) {
        v8450.add(p11463);
      }
    });
    this.bindSkeleton(p11460.skeletons, p11461, v8512);
    this.createAmbientLight();
    v8450.traverse(function (p11465) {
      if (p11465.userData.transformData) {
        if (p11465.parent) {
          p11465.userData.transformData.parentMatrix = p11465.parent.matrix;
          p11465.userData.transformData.parentMatrixWorld = p11465.parent.matrixWorld;
        }
        const vIii11 = f1462(p11465.userData.transformData);
        p11465.applyMatrix4(vIii11);
        p11465.updateWorldMatrix();
      }
    });
    const v8517 = new C250().parse();
    if (v8450.children.length === 1 && v8450.children[0].isGroup) {
      v8450.children[0].animations = v8517;
      v8450 = v8450.children[0];
    }
    v8450.animations = v8517;
  }
  parseModels(p11466, p11467, p11468) {
    const v8518 = new Map();
    const v8519 = v8448.Objects.Model;
    for (const v8520 in v8519) {
      const vParseInt23 = parseInt(v8520);
      const v8521 = v8519[v8520];
      const v8522 = v8449.get(vParseInt23);
      let v8523 = this.buildSkeleton(v8522, p11466, vParseInt23, v8521.attrName);
      if (!v8523) {
        switch (v8521.attrType) {
          case "Camera":
            v8523 = this.createCamera(v8522);
            break;
          case "Light":
            v8523 = this.createLight(v8522);
            break;
          case "Mesh":
            v8523 = this.createMesh(v8522, p11467, p11468);
            break;
          case "NurbsCurve":
            v8523 = this.createCurve(v8522, p11467);
            break;
          case "LimbNode":
          case "Root":
            v8523 = new THREE.Bone();
            break;
          case "Null":
          default:
            v8523 = new THREE.Group();
            break;
        }
        v8523.name = v8521.attrName ? THREE.PropertyBinding.sanitizeNodeName(v8521.attrName) : "";
        v8523.ID = vParseInt23;
      }
      this.getTransformData(v8523, v8521);
      v8518.set(vParseInt23, v8523);
    }
    return v8518;
  }
  buildSkeleton(p11469, p11470, p11471, p11472) {
    let v8524 = null;
    p11469.parents.forEach(function (p11473) {
      for (const v8525 in p11470) {
        const v8526 = p11470[v8525];
        v8526.rawBones.forEach(function (p11474, p11475) {
          if (p11474.ID === p11473.ID) {
            const vV8524 = v8524;
            v8524 = new THREE.Bone();
            v8524.matrixWorld.copy(p11474.transformLink);
            v8524.name = p11472 ? THREE.PropertyBinding.sanitizeNodeName(p11472) : "";
            v8524.ID = p11471;
            v8526.bones[p11475] = v8524;
            if (vV8524 !== null) {
              v8524.add(vV8524);
            }
          }
        });
      }
    });
    return v8524;
  }
  createCamera(p11476) {
    let v8527;
    let v8528;
    p11476.children.forEach(function (p11477) {
      const v8529 = v8448.Objects.NodeAttribute[p11477.ID];
      if (v8529 !== undefined) {
        v8528 = v8529;
      }
    });
    if (v8528 === undefined) {
      v8527 = new THREE.Object3D();
    } else {
      let vLN01412 = 0;
      if (v8528.CameraProjectionType !== undefined && v8528.CameraProjectionType.value === 1) {
        vLN01412 = 1;
      }
      let vLN1132 = 1;
      if (v8528.NearPlane !== undefined) {
        vLN1132 = v8528.NearPlane.value / 1000;
      }
      let vLN10002 = 1000;
      if (v8528.FarPlane !== undefined) {
        vLN10002 = v8528.FarPlane.value / 1000;
      }
      let v8530 = window.innerWidth;
      let v8531 = window.innerHeight;
      if (v8528.AspectWidth !== undefined && v8528.AspectHeight !== undefined) {
        v8530 = v8528.AspectWidth.value;
        v8531 = v8528.AspectHeight.value;
      }
      const v8532 = v8530 / v8531;
      let vLN452 = 45;
      if (v8528.FieldOfView !== undefined) {
        vLN452 = v8528.FieldOfView.value;
      }
      const v8533 = v8528.FocalLength ? v8528.FocalLength.value : null;
      switch (vLN01412) {
        case 0:
          v8527 = new THREE.PerspectiveCamera(vLN452, v8532, vLN1132, vLN10002);
          if (v8533 !== null) {
            v8527.setFocalLength(v8533);
          }
          break;
        case 1:
          v8527 = new THREE.OrthographicCamera(-v8530 / 2, v8530 / 2, v8531 / 2, -v8531 / 2, vLN1132, vLN10002);
          break;
        default:
          console.warn("THREE.FBXLoader: Unknown camera type " + vLN01412 + ".");
          v8527 = new THREE.Object3D();
          break;
      }
    }
    return v8527;
  }
  createLight(p11478) {
    let v8534;
    let v8535;
    p11478.children.forEach(function (p11479) {
      const v8536 = v8448.Objects.NodeAttribute[p11479.ID];
      if (v8536 !== undefined) {
        v8535 = v8536;
      }
    });
    if (v8535 === undefined) {
      v8534 = new THREE.Object3D();
    } else {
      let v8537;
      if (v8535.LightType === undefined) {
        v8537 = 0;
      } else {
        v8537 = v8535.LightType.value;
      }
      let vLN16777215 = 16777215;
      if (v8535.Color !== undefined) {
        vLN16777215 = new THREE.Color().fromArray(v8535.Color.value);
      }
      let v8538 = v8535.Intensity === undefined ? 1 : v8535.Intensity.value / 100;
      if (v8535.CastLightOnObject !== undefined && v8535.CastLightOnObject.value === 0) {
        v8538 = 0;
      }
      let vLN01413 = 0;
      if (v8535.FarAttenuationEnd !== undefined) {
        if (v8535.EnableFarAttenuation !== undefined && v8535.EnableFarAttenuation.value === 0) {
          vLN01413 = 0;
        } else {
          vLN01413 = v8535.FarAttenuationEnd.value;
        }
      }
      const vLN1133 = 1;
      switch (v8537) {
        case 0:
          v8534 = new THREE.PointLight(vLN16777215, v8538, vLN01413, vLN1133);
          break;
        case 1:
          v8534 = new THREE.DirectionalLight(vLN16777215, v8538);
          break;
        case 2:
          let v8539 = Math.PI / 3;
          if (v8535.InnerAngle !== undefined) {
            v8539 = THREE.MathUtils.degToRad(v8535.InnerAngle.value);
          }
          let vLN01414 = 0;
          if (v8535.OuterAngle !== undefined) {
            vLN01414 = THREE.MathUtils.degToRad(v8535.OuterAngle.value);
            vLN01414 = Math.max(vLN01414, 1);
          }
          v8534 = new THREE.SpotLight(vLN16777215, v8538, vLN01413, v8539, vLN01414, vLN1133);
          break;
        default:
          console.warn("THREE.FBXLoader: Unknown light type " + v8535.LightType.value + ", defaulting to a PointLight.");
          v8534 = new THREE.PointLight(vLN16777215, v8538);
          break;
      }
      if (v8535.CastShadows !== undefined && v8535.CastShadows.value === 1) {
        v8534.castShadow = true;
      }
    }
    return v8534;
  }
  createMesh(p11480, p11481, p11482) {
    let v8540;
    let v8541 = null;
    let v8542 = null;
    const vA439 = [];
    p11480.children.forEach(function (p11483) {
      if (p11481.has(p11483.ID)) {
        v8541 = p11481.get(p11483.ID);
      }
      if (p11482.has(p11483.ID)) {
        vA439.push(p11482.get(p11483.ID));
      }
    });
    if (vA439.length > 1) {
      v8542 = vA439;
    } else if (vA439.length > 0) {
      v8542 = vA439[0];
    } else {
      v8542 = new THREE.MeshPhongMaterial({
        color: 13421772
      });
      vA439.push(v8542);
    }
    if ("color" in v8541.attributes) {
      vA439.forEach(function (p11484) {
        p11484.vertexColors = true;
      });
    }
    if (v8541.FBX_Deformer) {
      v8540 = new THREE.SkinnedMesh(v8541, v8542);
      v8540.normalizeSkinWeights();
    } else {
      v8540 = new THREE.Mesh(v8541, v8542);
    }
    return v8540;
  }
  createCurve(p11485, p11486) {
    const v8543 = p11485.children.reduce(function (p11487, p11488) {
      if (p11486.has(p11488.ID)) {
        p11487 = p11486.get(p11488.ID);
      }
      return p11487;
    }, null);
    const v8544 = new THREE.LineBasicMaterial({
      color: 3342591,
      linewidth: 1
    });
    return new THREE.Line(v8543, v8544);
  }
  getTransformData(p11489, p11490) {
    const vO258 = {};
    if ("InheritType" in p11490) {
      vO258.inheritType = parseInt(p11490.InheritType.value);
    }
    if ("RotationOrder" in p11490) {
      vO258.eulerOrder = f1463(p11490.RotationOrder.value);
    } else {
      vO258.eulerOrder = "ZYX";
    }
    if ("Lcl_Translation" in p11490) {
      vO258.translation = p11490.Lcl_Translation.value;
    }
    if ("PreRotation" in p11490) {
      vO258.preRotation = p11490.PreRotation.value;
    }
    if ("Lcl_Rotation" in p11490) {
      vO258.rotation = p11490.Lcl_Rotation.value;
    }
    if ("PostRotation" in p11490) {
      vO258.postRotation = p11490.PostRotation.value;
    }
    if ("Lcl_Scaling" in p11490) {
      vO258.scale = p11490.Lcl_Scaling.value;
    }
    if ("ScalingOffset" in p11490) {
      vO258.scalingOffset = p11490.ScalingOffset.value;
    }
    if ("ScalingPivot" in p11490) {
      vO258.scalingPivot = p11490.ScalingPivot.value;
    }
    if ("RotationOffset" in p11490) {
      vO258.rotationOffset = p11490.RotationOffset.value;
    }
    if ("RotationPivot" in p11490) {
      vO258.rotationPivot = p11490.RotationPivot.value;
    }
    p11489.userData.transformData = vO258;
  }
  setLookAtProperties(p11491, p11492) {
    if ("LookAtProperty" in p11492) {
      const v8545 = v8449.get(p11491.ID).children;
      v8545.forEach(function (p11493) {
        if (p11493.relationship === "LookAtProperty") {
          const v8546 = v8448.Objects.Model[p11493.ID];
          if ("Lcl_Translation" in v8546) {
            const v8547 = v8546.Lcl_Translation.value;
            if (p11491.target !== undefined) {
              p11491.target.position.fromArray(v8547);
              v8450.add(p11491.target);
            } else {
              p11491.lookAt(new THREE.Vector3().fromArray(v8547));
            }
          }
        }
      });
    }
  }
  bindSkeleton(p11494, p11495, p11496) {
    const v8548 = this.parsePoseNodes();
    for (const v8549 in p11494) {
      const v8550 = p11494[v8549];
      const v8551 = v8449.get(parseInt(v8550.ID)).parents;
      v8551.forEach(function (p11497) {
        if (p11495.has(p11497.ID)) {
          const v8552 = p11497.ID;
          const v8553 = v8449.get(v8552);
          v8553.parents.forEach(function (p11498) {
            if (p11496.has(p11498.ID)) {
              const v8554 = p11496.get(p11498.ID);
              v8554.bind(new THREE.Skeleton(v8550.bones), v8548[p11498.ID]);
            }
          });
        }
      });
    }
  }
  parsePoseNodes() {
    const vO259 = {};
    if ("Pose" in v8448.Objects) {
      const v8555 = v8448.Objects.Pose;
      for (const v8556 in v8555) {
        if (v8555[v8556].attrType === "BindPose" && v8555[v8556].NbPoseNodes > 0) {
          const v8557 = v8555[v8556].PoseNode;
          if (Array.isArray(v8557)) {
            v8557.forEach(function (p11499) {
              vO259[p11499.Node] = new THREE.Matrix4().fromArray(p11499.Matrix.a);
            });
          } else {
            vO259[v8557.Node] = new THREE.Matrix4().fromArray(v8557.Matrix.a);
          }
        }
      }
    }
    return vO259;
  }
  createAmbientLight() {
    if ("GlobalSettings" in v8448 && "AmbientColor" in v8448.GlobalSettings) {
      const v8558 = v8448.GlobalSettings.AmbientColor.value;
      const v8559 = v8558[0];
      const v8560 = v8558[1];
      const v8561 = v8558[2];
      if (v8559 !== 0 || v8560 !== 0 || v8561 !== 0) {
        const v8562 = new THREE.Color(v8559, v8560, v8561);
        v8450.add(new THREE.AmbientLight(v8562, 1));
      }
    }
  }
}
class C249 {
  constructor() {
    this.negativeMaterialIndices = false;
  }
  parse(p11500) {
    const v8563 = new Map();
    if ("Geometry" in v8448.Objects) {
      const v8564 = v8448.Objects.Geometry;
      for (const v8565 in v8564) {
        const v8566 = v8449.get(parseInt(v8565));
        const v8567 = this.parseGeometry(v8566, v8564[v8565], p11500);
        v8563.set(parseInt(v8565), v8567);
      }
    }
    if (this.negativeMaterialIndices === true) {
      console.warn("THREE.FBXLoader: The FBX file contains invalid (negative) material indices. The asset might not render as expected.");
    }
    return v8563;
  }
  parseGeometry(p11501, p11502, p11503) {
    switch (p11502.attrType) {
      case "Mesh":
        return this.parseMeshGeometry(p11501, p11502, p11503);
        break;
      case "NurbsCurve":
        return this.parseNurbsGeometry(p11502);
        break;
    }
  }
  parseMeshGeometry(p11504, p11505, p11506) {
    const v8568 = p11506.skeletons;
    const vA440 = [];
    const v8569 = p11504.parents.map(function (p11507) {
      return v8448.Objects.Model[p11507.ID];
    });
    if (v8569.length === 0) {
      return;
    }
    const v8570 = p11504.children.reduce(function (p11508, p11509) {
      if (v8568[p11509.ID] !== undefined) {
        p11508 = v8568[p11509.ID];
      }
      return p11508;
    }, null);
    p11504.children.forEach(function (p11510) {
      if (p11506.morphTargets[p11510.ID] !== undefined) {
        vA440.push(p11506.morphTargets[p11510.ID]);
      }
    });
    const v8571 = v8569[0];
    const vO260 = {};
    if ("RotationOrder" in v8571) {
      vO260.eulerOrder = f1463(v8571.RotationOrder.value);
    }
    if ("InheritType" in v8571) {
      vO260.inheritType = parseInt(v8571.InheritType.value);
    }
    if ("GeometricTranslation" in v8571) {
      vO260.translation = v8571.GeometricTranslation.value;
    }
    if ("GeometricRotation" in v8571) {
      vO260.rotation = v8571.GeometricRotation.value;
    }
    if ("GeometricScaling" in v8571) {
      vO260.scale = v8571.GeometricScaling.value;
    }
    const vIii12 = f1462(vO260);
    return this.genGeometry(p11505, v8570, vA440, vIii12);
  }
  genGeometry(p11511, p11512, p11513, p11514) {
    const v8572 = new THREE.BufferGeometry();
    if (p11511.attrName) {
      v8572.name = p11511.attrName;
    }
    const v8573 = this.parseGeoNode(p11511, p11512);
    const v8574 = this.genBuffers(v8573);
    const v8575 = new THREE.Float32BufferAttribute(v8574.vertex, 3);
    v8575.applyMatrix4(p11514);
    v8572.setAttribute("position", v8575);
    if (v8574.colors.length > 0) {
      v8572.setAttribute("color", new THREE.Float32BufferAttribute(v8574.colors, 3));
    }
    if (p11512) {
      v8572.setAttribute("skinIndex", new THREE.Uint16BufferAttribute(v8574.weightsIndices, 4));
      v8572.setAttribute("skinWeight", new THREE.Float32BufferAttribute(v8574.vertexWeights, 4));
      v8572.FBX_Deformer = p11512;
    }
    if (v8574.normal.length > 0) {
      const v8576 = new THREE.Matrix3().getNormalMatrix(p11514);
      const v8577 = new THREE.Float32BufferAttribute(v8574.normal, 3);
      v8577.applyNormalMatrix(v8576);
      v8572.setAttribute("normal", v8577);
    }
    v8574.uvs.forEach(function (p11515, p11516) {
      let v8578 = "uv" + (p11516 + 1).toString();
      if (p11516 === 0) {
        v8578 = "uv";
      }
      v8572.setAttribute(v8578, new THREE.Float32BufferAttribute(v8574.uvs[p11516], 2));
    });
    if (v8573.material && v8573.material.mappingType !== "AllSame") {
      let v8579 = v8574.materialIndex[0];
      let vLN01415 = 0;
      v8574.materialIndex.forEach(function (p11517, p11518) {
        if (p11517 !== v8579) {
          v8572.addGroup(vLN01415, p11518 - vLN01415, v8579);
          v8579 = p11517;
          vLN01415 = p11518;
        }
      });
      if (v8572.groups.length > 0) {
        const v8580 = v8572.groups[v8572.groups.length - 1];
        const v8581 = v8580.start + v8580.count;
        if (v8581 !== v8574.materialIndex.length) {
          v8572.addGroup(v8581, v8574.materialIndex.length - v8581, v8579);
        }
      }
      if (v8572.groups.length === 0) {
        v8572.addGroup(0, v8574.materialIndex.length, v8574.materialIndex[0]);
      }
    }
    this.addMorphTargets(v8572, p11511, p11513, p11514);
    return v8572;
  }
  parseGeoNode(p11519, p11520) {
    const vO261 = {
      vertexPositions: p11519.Vertices !== undefined ? p11519.Vertices.a : [],
      vertexIndices: p11519.PolygonVertexIndex !== undefined ? p11519.PolygonVertexIndex.a : []
    };
    if (p11519.LayerElementColor) {
      vO261.color = this.parseVertexColors(p11519.LayerElementColor[0]);
    }
    if (p11519.LayerElementMaterial) {
      vO261.material = this.parseMaterialIndices(p11519.LayerElementMaterial[0]);
    }
    if (p11519.LayerElementNormal) {
      vO261.normal = this.parseNormals(p11519.LayerElementNormal[0]);
    }
    if (p11519.LayerElementUV) {
      vO261.uv = [];
      let vLN01416 = 0;
      while (p11519.LayerElementUV[vLN01416]) {
        if (p11519.LayerElementUV[vLN01416].UV) {
          vO261.uv.push(this.parseUVs(p11519.LayerElementUV[vLN01416]));
        }
        vLN01416++;
      }
    }
    vO261.weightTable = {};
    if (p11520 !== null) {
      vO261.skeleton = p11520;
      p11520.rawBones.forEach(function (p11521, p11522) {
        p11521.indices.forEach(function (p11523, p11524) {
          if (vO261.weightTable[p11523] === undefined) {
            vO261.weightTable[p11523] = [];
          }
          vO261.weightTable[p11523].push({
            id: p11522,
            weight: p11521.weights[p11524]
          });
        });
      });
    }
    return vO261;
  }
  genBuffers(p11525) {
    const vO262 = {
      vertex: [],
      normal: [],
      colors: [],
      uvs: [],
      materialIndex: [],
      vertexWeights: [],
      weightsIndices: []
    };
    let vLN01417 = 0;
    let vLN01418 = 0;
    let v8582 = false;
    let vA441 = [];
    let vA442 = [];
    let vA443 = [];
    let vA444 = [];
    let vA445 = [];
    let vA446 = [];
    const vThis74 = this;
    p11525.vertexIndices.forEach(function (p11526, p11527) {
      let v8583;
      let v8584 = false;
      if (p11526 < 0) {
        p11526 = p11526 ^ -1;
        v8584 = true;
      }
      let vA447 = [];
      let vA448 = [];
      vA441.push(p11526 * 3, p11526 * 3 + 1, p11526 * 3 + 2);
      if (p11525.color) {
        const vIiii9 = f1461(p11527, vLN01417, p11526, p11525.color);
        vA443.push(vIiii9[0], vIiii9[1], vIiii9[2]);
      }
      if (p11525.skeleton) {
        if (p11525.weightTable[p11526] !== undefined) {
          p11525.weightTable[p11526].forEach(function (p11528) {
            vA448.push(p11528.weight);
            vA447.push(p11528.id);
          });
        }
        if (vA448.length > 4) {
          if (!v8582) {
            console.warn("THREE.FBXLoader: Vertex has more than 4 skinning weights assigned to vertex. Deleting additional weights.");
            v8582 = true;
          }
          const vA449 = [0, 0, 0, 0];
          const vA450 = [0, 0, 0, 0];
          vA448.forEach(function (p11529, p11530) {
            let vP11529 = p11529;
            let v8585 = vA447[p11530];
            vA450.forEach(function (p11531, p11532, p11533) {
              if (vP11529 > p11531) {
                p11533[p11532] = vP11529;
                vP11529 = p11531;
                const v8586 = vA449[p11532];
                vA449[p11532] = v8585;
                v8585 = v8586;
              }
            });
          });
          vA447 = vA449;
          vA448 = vA450;
        }
        while (vA448.length < 4) {
          vA448.push(0);
          vA447.push(0);
        }
        for (let vLN01419 = 0; vLN01419 < 4; ++vLN01419) {
          vA445.push(vA448[vLN01419]);
          vA446.push(vA447[vLN01419]);
        }
      }
      if (p11525.normal) {
        const vIiii10 = f1461(p11527, vLN01417, p11526, p11525.normal);
        vA442.push(vIiii10[0], vIiii10[1], vIiii10[2]);
      }
      if (p11525.material && p11525.material.mappingType !== "AllSame") {
        v8583 = f1461(p11527, vLN01417, p11526, p11525.material)[0];
        if (v8583 < 0) {
          vThis74.negativeMaterialIndices = true;
          v8583 = 0;
        }
      }
      if (p11525.uv) {
        p11525.uv.forEach(function (p11534, p11535) {
          const vIiii11 = f1461(p11527, vLN01417, p11526, p11534);
          if (vA444[p11535] === undefined) {
            vA444[p11535] = [];
          }
          vA444[p11535].push(vIiii11[0]);
          vA444[p11535].push(vIiii11[1]);
        });
      }
      vLN01418++;
      if (v8584) {
        if (vLN01418 > 4) {
          console.warn("THREE.FBXLoader: Polygons with more than four sides are not supported. Make sure to triangulate the geometry during export.");
        }
        vThis74.genFace(vO262, p11525, vA441, v8583, vA442, vA443, vA444, vA445, vA446, vLN01418);
        vLN01417++;
        vLN01418 = 0;
        vA441 = [];
        vA442 = [];
        vA443 = [];
        vA444 = [];
        vA445 = [];
        vA446 = [];
      }
    });
    return vO262;
  }
  genFace(p11536, p11537, p11538, p11539, p11540, p11541, p11542, p11543, p11544, p11545) {
    for (let vLN223 = 2; vLN223 < p11545; vLN223++) {
      p11536.vertex.push(p11537.vertexPositions[p11538[0]]);
      p11536.vertex.push(p11537.vertexPositions[p11538[1]]);
      p11536.vertex.push(p11537.vertexPositions[p11538[2]]);
      p11536.vertex.push(p11537.vertexPositions[p11538[(vLN223 - 1) * 3]]);
      p11536.vertex.push(p11537.vertexPositions[p11538[(vLN223 - 1) * 3 + 1]]);
      p11536.vertex.push(p11537.vertexPositions[p11538[(vLN223 - 1) * 3 + 2]]);
      p11536.vertex.push(p11537.vertexPositions[p11538[vLN223 * 3]]);
      p11536.vertex.push(p11537.vertexPositions[p11538[vLN223 * 3 + 1]]);
      p11536.vertex.push(p11537.vertexPositions[p11538[vLN223 * 3 + 2]]);
      if (p11537.skeleton) {
        p11536.vertexWeights.push(p11543[0]);
        p11536.vertexWeights.push(p11543[1]);
        p11536.vertexWeights.push(p11543[2]);
        p11536.vertexWeights.push(p11543[3]);
        p11536.vertexWeights.push(p11543[(vLN223 - 1) * 4]);
        p11536.vertexWeights.push(p11543[(vLN223 - 1) * 4 + 1]);
        p11536.vertexWeights.push(p11543[(vLN223 - 1) * 4 + 2]);
        p11536.vertexWeights.push(p11543[(vLN223 - 1) * 4 + 3]);
        p11536.vertexWeights.push(p11543[vLN223 * 4]);
        p11536.vertexWeights.push(p11543[vLN223 * 4 + 1]);
        p11536.vertexWeights.push(p11543[vLN223 * 4 + 2]);
        p11536.vertexWeights.push(p11543[vLN223 * 4 + 3]);
        p11536.weightsIndices.push(p11544[0]);
        p11536.weightsIndices.push(p11544[1]);
        p11536.weightsIndices.push(p11544[2]);
        p11536.weightsIndices.push(p11544[3]);
        p11536.weightsIndices.push(p11544[(vLN223 - 1) * 4]);
        p11536.weightsIndices.push(p11544[(vLN223 - 1) * 4 + 1]);
        p11536.weightsIndices.push(p11544[(vLN223 - 1) * 4 + 2]);
        p11536.weightsIndices.push(p11544[(vLN223 - 1) * 4 + 3]);
        p11536.weightsIndices.push(p11544[vLN223 * 4]);
        p11536.weightsIndices.push(p11544[vLN223 * 4 + 1]);
        p11536.weightsIndices.push(p11544[vLN223 * 4 + 2]);
        p11536.weightsIndices.push(p11544[vLN223 * 4 + 3]);
      }
      if (p11537.color) {
        p11536.colors.push(p11541[0]);
        p11536.colors.push(p11541[1]);
        p11536.colors.push(p11541[2]);
        p11536.colors.push(p11541[(vLN223 - 1) * 3]);
        p11536.colors.push(p11541[(vLN223 - 1) * 3 + 1]);
        p11536.colors.push(p11541[(vLN223 - 1) * 3 + 2]);
        p11536.colors.push(p11541[vLN223 * 3]);
        p11536.colors.push(p11541[vLN223 * 3 + 1]);
        p11536.colors.push(p11541[vLN223 * 3 + 2]);
      }
      if (p11537.material && p11537.material.mappingType !== "AllSame") {
        p11536.materialIndex.push(p11539);
        p11536.materialIndex.push(p11539);
        p11536.materialIndex.push(p11539);
      }
      if (p11537.normal) {
        p11536.normal.push(p11540[0]);
        p11536.normal.push(p11540[1]);
        p11536.normal.push(p11540[2]);
        p11536.normal.push(p11540[(vLN223 - 1) * 3]);
        p11536.normal.push(p11540[(vLN223 - 1) * 3 + 1]);
        p11536.normal.push(p11540[(vLN223 - 1) * 3 + 2]);
        p11536.normal.push(p11540[vLN223 * 3]);
        p11536.normal.push(p11540[vLN223 * 3 + 1]);
        p11536.normal.push(p11540[vLN223 * 3 + 2]);
      }
      if (p11537.uv) {
        p11537.uv.forEach(function (p11546, p11547) {
          if (p11536.uvs[p11547] === undefined) {
            p11536.uvs[p11547] = [];
          }
          p11536.uvs[p11547].push(p11542[p11547][0]);
          p11536.uvs[p11547].push(p11542[p11547][1]);
          p11536.uvs[p11547].push(p11542[p11547][(vLN223 - 1) * 2]);
          p11536.uvs[p11547].push(p11542[p11547][(vLN223 - 1) * 2 + 1]);
          p11536.uvs[p11547].push(p11542[p11547][vLN223 * 2]);
          p11536.uvs[p11547].push(p11542[p11547][vLN223 * 2 + 1]);
        });
      }
    }
  }
  addMorphTargets(p11548, p11549, p11550, p11551) {
    if (p11550.length === 0) {
      return;
    }
    p11548.morphTargetsRelative = true;
    p11548.morphAttributes.position = [];
    const vThis75 = this;
    p11550.forEach(function (p11552) {
      p11552.rawTargets.forEach(function (p11553) {
        const v8587 = v8448.Objects.Geometry[p11553.geoID];
        if (v8587 !== undefined) {
          vThis75.genMorphGeometry(p11548, p11549, v8587, p11551, p11553.name);
        }
      });
    });
  }
  genMorphGeometry(p11554, p11555, p11556, p11557, p11558) {
    const v8588 = p11555.PolygonVertexIndex !== undefined ? p11555.PolygonVertexIndex.a : [];
    const v8589 = p11556.Vertices !== undefined ? p11556.Vertices.a : [];
    const v8590 = p11556.Indexes !== undefined ? p11556.Indexes.a : [];
    const v8591 = p11554.attributes.position.count * 3;
    const v8592 = new Float32Array(v8591);
    for (let vLN01420 = 0; vLN01420 < v8590.length; vLN01420++) {
      const v8593 = v8590[vLN01420] * 3;
      v8592[v8593] = v8589[vLN01420 * 3];
      v8592[v8593 + 1] = v8589[vLN01420 * 3 + 1];
      v8592[v8593 + 2] = v8589[vLN01420 * 3 + 2];
    }
    const vO263 = {
      vertexIndices: v8588,
      vertexPositions: v8592
    };
    const v8594 = this.genBuffers(vO263);
    const v8595 = new THREE.Float32BufferAttribute(v8594.vertex, 3);
    v8595.name = p11558 || p11556.attrName;
    v8595.applyMatrix4(p11557);
    p11554.morphAttributes.position.push(v8595);
  }
  parseNormals(p11559) {
    const v8596 = p11559.MappingInformationType;
    const v8597 = p11559.ReferenceInformationType;
    const v8598 = p11559.Normals.a;
    let vA451 = [];
    if (v8597 === "IndexToDirect") {
      if ("NormalIndex" in p11559) {
        vA451 = p11559.NormalIndex.a;
      } else if ("NormalsIndex" in p11559) {
        vA451 = p11559.NormalsIndex.a;
      }
    }
    return {
      dataSize: 3,
      buffer: v8598,
      indices: vA451,
      mappingType: v8596,
      referenceType: v8597
    };
  }
  parseUVs(p11560) {
    const v8599 = p11560.MappingInformationType;
    const v8600 = p11560.ReferenceInformationType;
    const v8601 = p11560.UV.a;
    let vA452 = [];
    if (v8600 === "IndexToDirect") {
      vA452 = p11560.UVIndex.a;
    }
    return {
      dataSize: 2,
      buffer: v8601,
      indices: vA452,
      mappingType: v8599,
      referenceType: v8600
    };
  }
  parseVertexColors(p11561) {
    const v8602 = p11561.MappingInformationType;
    const v8603 = p11561.ReferenceInformationType;
    const v8604 = p11561.Colors.a;
    let vA453 = [];
    if (v8603 === "IndexToDirect") {
      vA453 = p11561.ColorIndex.a;
    }
    return {
      dataSize: 4,
      buffer: v8604,
      indices: vA453,
      mappingType: v8602,
      referenceType: v8603
    };
  }
  parseMaterialIndices(p11562) {
    const v8605 = p11562.MappingInformationType;
    const v8606 = p11562.ReferenceInformationType;
    if (v8605 === "NoMappingInformation") {
      return {
        dataSize: 1,
        buffer: [0],
        indices: [0],
        mappingType: "AllSame",
        referenceType: v8606
      };
    }
    const v8607 = p11562.Materials.a;
    const vA454 = [];
    for (let vLN01421 = 0; vLN01421 < v8607.length; ++vLN01421) {
      vA454.push(vLN01421);
    }
    return {
      dataSize: 1,
      buffer: v8607,
      indices: vA454,
      mappingType: v8605,
      referenceType: v8606
    };
  }
  parseNurbsGeometry(p11563) {
    const vParseInt24 = parseInt(p11563.Order);
    if (isNaN(vParseInt24)) {
      console.error("THREE.FBXLoader: Invalid Order %s given for geometry ID: %s", p11563.Order, p11563.id);
      return new THREE.BufferGeometry();
    }
    const v8608 = vParseInt24 - 1;
    const v8609 = p11563.KnotVector.a;
    const vA455 = [];
    const v8610 = p11563.Points.a;
    for (let vLN01422 = 0, v8611 = v8610.length; vLN01422 < v8611; vLN01422 += 4) {
      vA455.push(new THREE.Vector4().fromArray(v8610, vLN01422));
    }
    let v8612;
    let v8613;
    if (p11563.Form === "Closed") {
      vA455.push(vA455[0]);
    } else if (p11563.Form === "Periodic") {
      v8612 = v8608;
      v8613 = v8609.length - 1 - v8612;
      for (let vLN01423 = 0; vLN01423 < v8608; ++vLN01423) {
        vA455.push(vA455[vLN01423]);
      }
    }
    const v8614 = new C246(v8608, v8609, vA455, v8612, v8613);
    const v8615 = v8614.getPoints(vA455.length * 12);
    return new THREE.BufferGeometry().setFromPoints(v8615);
  }
}
class C250 {
  parse() {
    const vA456 = [];
    const v8616 = this.parseClips();
    if (v8616 !== undefined) {
      for (const v8617 in v8616) {
        const v8618 = v8616[v8617];
        const v8619 = this.addClip(v8618);
        vA456.push(v8619);
      }
    }
    return vA456;
  }
  parseClips() {
    if (v8448.Objects.AnimationCurve === undefined) {
      return undefined;
    }
    const v8620 = this.parseAnimationCurveNodes();
    this.parseAnimationCurves(v8620);
    const v8621 = this.parseAnimationLayers(v8620);
    const v8622 = this.parseAnimStacks(v8621);
    return v8622;
  }
  parseAnimationCurveNodes() {
    const v8623 = v8448.Objects.AnimationCurveNode;
    const v8624 = new Map();
    for (const v8625 in v8623) {
      const v8626 = v8623[v8625];
      if (v8626.attrName.match(/S|R|T|DeformPercent/) !== null) {
        const vO264 = {
          id: v8626.id,
          attr: v8626.attrName,
          curves: {}
        };
        v8624.set(vO264.id, vO264);
      }
    }
    return v8624;
  }
  parseAnimationCurves(p11564) {
    const v8627 = v8448.Objects.AnimationCurve;
    for (const v8628 in v8627) {
      const vO265 = {
        id: v8627[v8628].id,
        times: v8627[v8628].KeyTime.a.map(f1460),
        values: v8627[v8628].KeyValueFloat.a
      };
      const v8629 = v8449.get(vO265.id);
      if (v8629 !== undefined) {
        const v8630 = v8629.parents[0].ID;
        const v8631 = v8629.parents[0].relationship;
        if (v8631.match(/X/)) {
          p11564.get(v8630).curves.x = vO265;
        } else if (v8631.match(/Y/)) {
          p11564.get(v8630).curves.y = vO265;
        } else if (v8631.match(/Z/)) {
          p11564.get(v8630).curves.z = vO265;
        } else if (v8631.match(/d|DeformPercent/) && p11564.has(v8630)) {
          p11564.get(v8630).curves.morph = vO265;
        }
      }
    }
  }
  parseAnimationLayers(p11565) {
    const v8632 = v8448.Objects.AnimationLayer;
    const v8633 = new Map();
    for (const v8634 in v8632) {
      const vA457 = [];
      const v8635 = v8449.get(parseInt(v8634));
      if (v8635 !== undefined) {
        const v8636 = v8635.children;
        v8636.forEach(function (p11566, p11567) {
          if (p11565.has(p11566.ID)) {
            const v8637 = p11565.get(p11566.ID);
            if (v8637.curves.x !== undefined || v8637.curves.y !== undefined || v8637.curves.z !== undefined) {
              if (vA457[p11567] === undefined) {
                const v8638 = v8449.get(p11566.ID).parents.filter(function (p11568) {
                  return p11568.relationship !== undefined;
                })[0].ID;
                if (v8638 !== undefined) {
                  const v8639 = v8448.Objects.Model[v8638.toString()];
                  if (v8639 === undefined) {
                    console.warn("THREE.FBXLoader: Encountered a unused curve.", p11566);
                    return;
                  }
                  const vO266 = {
                    modelName: v8639.attrName ? THREE.PropertyBinding.sanitizeNodeName(v8639.attrName) : "",
                    ID: v8639.id,
                    initialPosition: [0, 0, 0],
                    initialRotation: [0, 0, 0],
                    initialScale: [1, 1, 1]
                  };
                  v8450.traverse(function (p11569) {
                    if (p11569.ID === v8639.id) {
                      vO266.transform = p11569.matrix;
                      if (p11569.userData.transformData) {
                        vO266.eulerOrder = p11569.userData.transformData.eulerOrder;
                      }
                    }
                  });
                  if (!vO266.transform) {
                    vO266.transform = new THREE.Matrix4();
                  }
                  if ("PreRotation" in v8639) {
                    vO266.preRotation = v8639.PreRotation.value;
                  }
                  if ("PostRotation" in v8639) {
                    vO266.postRotation = v8639.PostRotation.value;
                  }
                  vA457[p11567] = vO266;
                }
              }
              if (vA457[p11567]) {
                vA457[p11567][v8637.attr] = v8637;
              }
            } else if (v8637.curves.morph !== undefined) {
              if (vA457[p11567] === undefined) {
                const v8640 = v8449.get(p11566.ID).parents.filter(function (p11570) {
                  return p11570.relationship !== undefined;
                })[0].ID;
                const v8641 = v8449.get(v8640).parents[0].ID;
                const v8642 = v8449.get(v8641).parents[0].ID;
                const v8643 = v8449.get(v8642).parents[0].ID;
                const v8644 = v8448.Objects.Model[v8643];
                const vO267 = {
                  modelName: v8644.attrName ? THREE.PropertyBinding.sanitizeNodeName(v8644.attrName) : "",
                  morphName: v8448.Objects.Deformer[v8640].attrName
                };
                vA457[p11567] = vO267;
              }
              vA457[p11567][v8637.attr] = v8637;
            }
          }
        });
        v8633.set(parseInt(v8634), vA457);
      }
    }
    return v8633;
  }
  parseAnimStacks(p11571) {
    const v8645 = v8448.Objects.AnimationStack;
    const vO268 = {};
    for (const v8646 in v8645) {
      const v8647 = v8449.get(parseInt(v8646)).children;
      if (v8647.length > 1) {
        console.warn("THREE.FBXLoader: Encountered an animation stack with multiple layers, this is currently not supported. Ignoring subsequent layers.");
      }
      const v8648 = p11571.get(v8647[0].ID);
      vO268[v8646] = {
        name: v8645[v8646].attrName,
        layer: v8648
      };
    }
    return vO268;
  }
  addClip(p11572) {
    let vA458 = [];
    const vThis76 = this;
    p11572.layer.forEach(function (p11573) {
      vA458 = vA458.concat(vThis76.generateTracks(p11573));
    });
    return new THREE.AnimationClip(p11572.name, -1, vA458);
  }
  generateTracks(p11574) {
    const vA459 = [];
    let v8649 = new THREE.Vector3();
    let v8650 = new THREE.Quaternion();
    let v8651 = new THREE.Vector3();
    if (p11574.transform) {
      p11574.transform.decompose(v8649, v8650, v8651);
    }
    v8649 = v8649.toArray();
    v8650 = new THREE.Euler().setFromQuaternion(v8650, p11574.eulerOrder).toArray();
    v8651 = v8651.toArray();
    if (p11574.T !== undefined && Object.keys(p11574.T.curves).length > 0) {
      const v8652 = this.generateVectorTrack(p11574.modelName, p11574.T.curves, v8649, "position");
      if (v8652 !== undefined) {
        vA459.push(v8652);
      }
    }
    if (p11574.R !== undefined && Object.keys(p11574.R.curves).length > 0) {
      const v8653 = this.generateRotationTrack(p11574.modelName, p11574.R.curves, v8650, p11574.preRotation, p11574.postRotation, p11574.eulerOrder);
      if (v8653 !== undefined) {
        vA459.push(v8653);
      }
    }
    if (p11574.S !== undefined && Object.keys(p11574.S.curves).length > 0) {
      const v8654 = this.generateVectorTrack(p11574.modelName, p11574.S.curves, v8651, "scale");
      if (v8654 !== undefined) {
        vA459.push(v8654);
      }
    }
    if (p11574.DeformPercent !== undefined) {
      const v8655 = this.generateMorphTrack(p11574);
      if (v8655 !== undefined) {
        vA459.push(v8655);
      }
    }
    return vA459;
  }
  generateVectorTrack(p11575, p11576, p11577, p11578) {
    const v8656 = this.getTimesForAllAxes(p11576);
    const v8657 = this.getKeyframeTrackValues(v8656, p11576, p11577);
    return new THREE.VectorKeyframeTrack(p11575 + "." + p11578, v8656, v8657);
  }
  generateRotationTrack(p11579, p11580, p11581, p11582, p11583, p11584) {
    if (p11580.x !== undefined) {
      this.interpolateRotations(p11580.x);
      p11580.x.values = p11580.x.values.map(THREE.MathUtils.degToRad);
    }
    if (p11580.y !== undefined) {
      this.interpolateRotations(p11580.y);
      p11580.y.values = p11580.y.values.map(THREE.MathUtils.degToRad);
    }
    if (p11580.z !== undefined) {
      this.interpolateRotations(p11580.z);
      p11580.z.values = p11580.z.values.map(THREE.MathUtils.degToRad);
    }
    const v8658 = this.getTimesForAllAxes(p11580);
    const v8659 = this.getKeyframeTrackValues(v8658, p11580, p11581);
    if (p11582 !== undefined) {
      p11582 = p11582.map(THREE.MathUtils.degToRad);
      p11582.push(p11584);
      p11582 = new THREE.Euler().fromArray(p11582);
      p11582 = new THREE.Quaternion().setFromEuler(p11582);
    }
    if (p11583 !== undefined) {
      p11583 = p11583.map(THREE.MathUtils.degToRad);
      p11583.push(p11584);
      p11583 = new THREE.Euler().fromArray(p11583);
      p11583 = new THREE.Quaternion().setFromEuler(p11583).invert();
    }
    const v8660 = new THREE.Quaternion();
    const v8661 = new THREE.Euler();
    const vA460 = [];
    for (let vLN01424 = 0; vLN01424 < v8659.length; vLN01424 += 3) {
      v8661.set(v8659[vLN01424], v8659[vLN01424 + 1], v8659[vLN01424 + 2], p11584);
      v8660.setFromEuler(v8661);
      if (p11582 !== undefined) {
        v8660.premultiply(p11582);
      }
      if (p11583 !== undefined) {
        v8660.multiply(p11583);
      }
      v8660.toArray(vA460, vLN01424 / 3 * 4);
    }
    return new THREE.QuaternionKeyframeTrack(p11579 + ".quaternion", v8658, vA460);
  }
  generateMorphTrack(p11585) {
    const v8662 = p11585.DeformPercent.curves.morph;
    const v8663 = v8662.values.map(function (p11586) {
      return p11586 / 100;
    });
    const v8664 = v8450.getObjectByName(p11585.modelName).morphTargetDictionary[p11585.morphName];
    return new THREE.NumberKeyframeTrack(p11585.modelName + ".morphTargetInfluences[" + v8664 + "]", v8662.times, v8663);
  }
  getTimesForAllAxes(p11587) {
    let vA461 = [];
    if (p11587.x !== undefined) {
      vA461 = vA461.concat(p11587.x.times);
    }
    if (p11587.y !== undefined) {
      vA461 = vA461.concat(p11587.y.times);
    }
    if (p11587.z !== undefined) {
      vA461 = vA461.concat(p11587.z.times);
    }
    vA461 = vA461.sort(function (p11588, p11589) {
      return p11588 - p11589;
    });
    if (vA461.length > 1) {
      let vLN1134 = 1;
      let v8665 = vA461[0];
      for (let vLN1135 = 1; vLN1135 < vA461.length; vLN1135++) {
        const v8666 = vA461[vLN1135];
        if (v8666 !== v8665) {
          vA461[vLN1134] = v8666;
          v8665 = v8666;
          vLN1134++;
        }
      }
      vA461 = vA461.slice(0, vLN1134);
    }
    return vA461;
  }
  getKeyframeTrackValues(p11590, p11591, p11592) {
    const vP11592 = p11592;
    const vA462 = [];
    let v8667 = -1;
    let v8668 = -1;
    let v8669 = -1;
    p11590.forEach(function (p11593) {
      if (p11591.x) {
        v8667 = p11591.x.times.indexOf(p11593);
      }
      if (p11591.y) {
        v8668 = p11591.y.times.indexOf(p11593);
      }
      if (p11591.z) {
        v8669 = p11591.z.times.indexOf(p11593);
      }
      if (v8667 !== -1) {
        const v8670 = p11591.x.values[v8667];
        vA462.push(v8670);
        vP11592[0] = v8670;
      } else {
        vA462.push(vP11592[0]);
      }
      if (v8668 !== -1) {
        const v8671 = p11591.y.values[v8668];
        vA462.push(v8671);
        vP11592[1] = v8671;
      } else {
        vA462.push(vP11592[1]);
      }
      if (v8669 !== -1) {
        const v8672 = p11591.z.values[v8669];
        vA462.push(v8672);
        vP11592[2] = v8672;
      } else {
        vA462.push(vP11592[2]);
      }
    });
    return vA462;
  }
  interpolateRotations(p11594) {
    for (let vLN1136 = 1; vLN1136 < p11594.values.length; vLN1136++) {
      const v8673 = p11594.values[vLN1136 - 1];
      const v8674 = p11594.values[vLN1136] - v8673;
      const v8675 = Math.abs(v8674);
      if (v8675 >= 180) {
        const v8676 = v8675 / 180;
        const v8677 = v8674 / v8676;
        let v8678 = v8673 + v8677;
        const v8679 = p11594.times[vLN1136 - 1];
        const v8680 = p11594.times[vLN1136] - v8679;
        const v8681 = v8680 / v8676;
        let v8682 = v8679 + v8681;
        const vA463 = [];
        const vA464 = [];
        while (v8682 < p11594.times[vLN1136]) {
          vA463.push(v8682);
          v8682 += v8681;
          vA464.push(v8678);
          v8678 += v8677;
        }
        p11594.times = f1468(p11594.times, vLN1136, vA463);
        p11594.values = f1468(p11594.values, vLN1136, vA464);
      }
    }
  }
}
class C251 {
  getPrevNode() {
    return this.nodeStack[this.currentIndent - 2];
  }
  getCurrentNode() {
    return this.nodeStack[this.currentIndent - 1];
  }
  getCurrentProp() {
    return this.currentProp;
  }
  pushStack(p11595) {
    this.nodeStack.push(p11595);
    this.currentIndent += 1;
  }
  popStack() {
    this.nodeStack.pop();
    this.currentIndent -= 1;
  }
  setCurrentProp(p11596, p11597) {
    this.currentProp = p11596;
    this.currentPropName = p11597;
  }
  parse(p11598) {
    this.currentIndent = 0;
    this.allNodes = new C254();
    this.nodeStack = [];
    this.currentProp = [];
    this.currentPropName = "";
    const vThis77 = this;
    const v8683 = p11598.split(/[\r\n]+/);
    v8683.forEach(function (p11599, p11600) {
      const v8684 = p11599.match(/^[\s\t]*;/);
      const v8685 = p11599.match(/^[\s\t]*$/);
      if (v8684 || v8685) {
        return;
      }
      const v8686 = p11599.match("^\\t{" + vThis77.currentIndent + "}(\\w+):(.*){", "");
      const v8687 = p11599.match("^\\t{" + vThis77.currentIndent + "}(\\w+):[\\s\\t\\r\\n](.*)");
      const v8688 = p11599.match("^\\t{" + (vThis77.currentIndent - 1) + "}}");
      if (v8686) {
        vThis77.parseNodeBegin(p11599, v8686);
      } else if (v8687) {
        vThis77.parseNodeProperty(p11599, v8687, v8683[++p11600]);
      } else if (v8688) {
        vThis77.popStack();
      } else if (p11599.match(/^[^\s\t}]/)) {
        vThis77.parseNodePropertyContinued(p11599);
      }
    });
    return this.allNodes;
  }
  parseNodeBegin(p11601, p11602) {
    const v8689 = p11602[1].trim().replace(/^"/, "").replace(/"$/, "");
    const v8690 = p11602[2].split(",").map(function (p11603) {
      return p11603.trim().replace(/^"/, "").replace(/"$/, "");
    });
    const vO269 = {
      name: v8689
    };
    const v8691 = this.parseNodeAttr(v8690);
    const v8692 = this.getCurrentNode();
    if (this.currentIndent === 0) {
      this.allNodes.add(v8689, vO269);
    } else if (v8689 in v8692) {
      if (v8689 === "PoseNode") {
        v8692.PoseNode.push(vO269);
      } else if (v8692[v8689].id !== undefined) {
        v8692[v8689] = {};
        v8692[v8689][v8692[v8689].id] = v8692[v8689];
      }
      if (v8691.id !== "") {
        v8692[v8689][v8691.id] = vO269;
      }
    } else if (typeof v8691.id === "number") {
      v8692[v8689] = {};
      v8692[v8689][v8691.id] = vO269;
    } else if (v8689 !== "Properties70") {
      if (v8689 === "PoseNode") {
        v8692[v8689] = [vO269];
      } else {
        v8692[v8689] = vO269;
      }
    }
    if (typeof v8691.id === "number") {
      vO269.id = v8691.id;
    }
    if (v8691.name !== "") {
      vO269.attrName = v8691.name;
    }
    if (v8691.type !== "") {
      vO269.attrType = v8691.type;
    }
    this.pushStack(vO269);
  }
  parseNodeAttr(p11604) {
    let v8693 = p11604[0];
    if (p11604[0] !== "") {
      v8693 = parseInt(p11604[0]);
      if (isNaN(v8693)) {
        v8693 = p11604[0];
      }
    }
    let vLS33 = "";
    let vLS34 = "";
    if (p11604.length > 1) {
      vLS33 = p11604[1].replace(/^(\w+)::/, "");
      vLS34 = p11604[2];
    }
    return {
      id: v8693,
      name: vLS33,
      type: vLS34
    };
  }
  parseNodeProperty(p11605, p11606, p11607) {
    let v8694 = p11606[1].replace(/^"/, "").replace(/"$/, "").trim();
    let v8695 = p11606[2].replace(/^"/, "").replace(/"$/, "").trim();
    if (v8694 === "Content" && v8695 === ",") {
      v8695 = p11607.replace(/"/g, "").replace(/,$/, "").trim();
    }
    const v8696 = this.getCurrentNode();
    const v8697 = v8696.name;
    if (v8697 === "Properties70") {
      this.parseNodeSpecialProperty(p11605, v8694, v8695);
      return;
    }
    if (v8694 === "C") {
      const v8698 = v8695.split(",").slice(1);
      const vParseInt25 = parseInt(v8698[0]);
      const vParseInt26 = parseInt(v8698[1]);
      let v8699 = v8695.split(",").slice(3);
      v8699 = v8699.map(function (p11608) {
        return p11608.trim().replace(/^"/, "");
      });
      v8694 = "connections";
      v8695 = [vParseInt25, vParseInt26];
      f1466(v8695, v8699);
      if (v8696[v8694] === undefined) {
        v8696[v8694] = [];
      }
    }
    if (v8694 === "Node") {
      v8696.id = v8695;
    }
    if (v8694 in v8696 && Array.isArray(v8696[v8694])) {
      v8696[v8694].push(v8695);
    } else if (v8694 !== "a") {
      v8696[v8694] = v8695;
    } else {
      v8696.a = v8695;
    }
    this.setCurrentProp(v8696, v8694);
    if (v8694 === "a" && v8695.slice(-1) !== ",") {
      v8696.a = f1464(v8695);
    }
  }
  parseNodePropertyContinued(p11609) {
    const v8700 = this.getCurrentNode();
    v8700.a += p11609;
    if (p11609.slice(-1) !== ",") {
      v8700.a = f1464(v8700.a);
    }
  }
  parseNodeSpecialProperty(p11610, p11611, p11612) {
    const v8701 = p11612.split("\",").map(function (p11613) {
      return p11613.trim().replace(/^\"/, "").replace(/\s/, "_");
    });
    const v8702 = v8701[0];
    const v8703 = v8701[1];
    const v8704 = v8701[2];
    const v8705 = v8701[3];
    let v8706 = v8701[4];
    switch (v8703) {
      case "int":
      case "enum":
      case "bool":
      case "ULongLong":
      case "double":
      case "Number":
      case "FieldOfView":
        v8706 = parseFloat(v8706);
        break;
      case "Color":
      case "ColorRGB":
      case "Vector3D":
      case "Lcl_Translation":
      case "Lcl_Rotation":
      case "Lcl_Scaling":
        v8706 = f1464(v8706);
        break;
    }
    this.getPrevNode()[v8702] = {
      type: v8703,
      type2: v8704,
      flag: v8705,
      value: v8706
    };
    this.setCurrentProp(this.getPrevNode(), v8702);
  }
}
class C252 {
  parse(p11614) {
    const v8707 = new C253(p11614);
    v8707.skip(23);
    const v8708 = v8707.getUint32();
    if (v8708 < 6400) {
      throw new Error("THREE.FBXLoader: FBX version not supported, FileVersion: " + v8708);
    }
    const v8709 = new C254();
    while (!this.endOfContent(v8707)) {
      const v8710 = this.parseNode(v8707, v8708);
      if (v8710 !== null) {
        v8709.add(v8710.name, v8710);
      }
    }
    return v8709;
  }
  endOfContent(p11615) {
    if (p11615.size() % 16 === 0) {
      return (p11615.getOffset() + 160 + 16 & ~15) >= p11615.size();
    } else {
      return p11615.getOffset() + 160 + 16 >= p11615.size();
    }
  }
  parseNode(p11616, p11617) {
    const vO270 = {};
    const v8711 = p11617 >= 7500 ? p11616.getUint64() : p11616.getUint32();
    const v8712 = p11617 >= 7500 ? p11616.getUint64() : p11616.getUint32();
    if (p11617 >= 7500) {
      p11616.getUint64();
    } else {
      p11616.getUint32();
    }
    const v8713 = p11616.getUint8();
    const v8714 = p11616.getString(v8713);
    if (v8711 === 0) {
      return null;
    }
    const vA465 = [];
    for (let vLN01425 = 0; vLN01425 < v8712; vLN01425++) {
      vA465.push(this.parseProperty(p11616));
    }
    const v8715 = vA465.length > 0 ? vA465[0] : "";
    const v8716 = vA465.length > 1 ? vA465[1] : "";
    const v8717 = vA465.length > 2 ? vA465[2] : "";
    vO270.singleProperty = v8712 === 1 && p11616.getOffset() === v8711 ? true : false;
    while (v8711 > p11616.getOffset()) {
      const v8718 = this.parseNode(p11616, p11617);
      if (v8718 !== null) {
        this.parseSubNode(v8714, vO270, v8718);
      }
    }
    vO270.propertyList = vA465;
    if (typeof v8715 === "number") {
      vO270.id = v8715;
    }
    if (v8716 !== "") {
      vO270.attrName = v8716;
    }
    if (v8717 !== "") {
      vO270.attrType = v8717;
    }
    if (v8714 !== "") {
      vO270.name = v8714;
    }
    return vO270;
  }
  parseSubNode(p11618, p11619, p11620) {
    if (p11620.singleProperty === true) {
      const v8719 = p11620.propertyList[0];
      if (Array.isArray(v8719)) {
        p11619[p11620.name] = p11620;
        p11620.a = v8719;
      } else {
        p11619[p11620.name] = v8719;
      }
    } else if (p11618 === "Connections" && p11620.name === "C") {
      const vA466 = [];
      p11620.propertyList.forEach(function (p11621, p11622) {
        if (p11622 !== 0) {
          vA466.push(p11621);
        }
      });
      if (p11619.connections === undefined) {
        p11619.connections = [];
      }
      p11619.connections.push(vA466);
    } else if (p11620.name === "Properties70") {
      const v8720 = Object.keys(p11620);
      v8720.forEach(function (p11623) {
        p11619[p11623] = p11620[p11623];
      });
    } else if (p11618 === "Properties70" && p11620.name === "P") {
      let v8721 = p11620.propertyList[0];
      let v8722 = p11620.propertyList[1];
      const v8723 = p11620.propertyList[2];
      const v8724 = p11620.propertyList[3];
      let v8725;
      if (v8721.indexOf("Lcl ") === 0) {
        v8721 = v8721.replace("Lcl ", "Lcl_");
      }
      if (v8722.indexOf("Lcl ") === 0) {
        v8722 = v8722.replace("Lcl ", "Lcl_");
      }
      if (v8722 === "Color" || v8722 === "ColorRGB" || v8722 === "Vector" || v8722 === "Vector3D" || v8722.indexOf("Lcl_") === 0) {
        v8725 = [p11620.propertyList[4], p11620.propertyList[5], p11620.propertyList[6]];
      } else {
        v8725 = p11620.propertyList[4];
      }
      p11619[v8721] = {
        type: v8722,
        type2: v8723,
        flag: v8724,
        value: v8725
      };
    } else if (p11619[p11620.name] === undefined) {
      if (typeof p11620.id === "number") {
        p11619[p11620.name] = {};
        p11619[p11620.name][p11620.id] = p11620;
      } else {
        p11619[p11620.name] = p11620;
      }
    } else if (p11620.name === "PoseNode") {
      if (!Array.isArray(p11619[p11620.name])) {
        p11619[p11620.name] = [p11619[p11620.name]];
      }
      p11619[p11620.name].push(p11620);
    } else if (p11619[p11620.name][p11620.id] === undefined) {
      p11619[p11620.name][p11620.id] = p11620;
    }
  }
  parseProperty(p11624) {
    const v8726 = p11624.getString(1);
    let v8727;
    switch (v8726) {
      case "C":
        return p11624.getBoolean();
      case "D":
        return p11624.getFloat64();
      case "F":
        return p11624.getFloat32();
      case "I":
        return p11624.getInt32();
      case "L":
        return p11624.getInt64();
      case "R":
        v8727 = p11624.getUint32();
        return p11624.getArrayBuffer(v8727);
      case "S":
        v8727 = p11624.getUint32();
        return p11624.getString(v8727);
      case "Y":
        return p11624.getInt16();
      case "b":
      case "c":
      case "d":
      case "f":
      case "i":
      case "l":
        const v8728 = p11624.getUint32();
        const v8729 = p11624.getUint32();
        const v8730 = p11624.getUint32();
        if (v8729 === 0) {
          switch (v8726) {
            case "b":
            case "c":
              return p11624.getBooleanArray(v8728);
            case "d":
              return p11624.getFloat64Array(v8728);
            case "f":
              return p11624.getFloat32Array(v8728);
            case "i":
              return p11624.getInt32Array(v8728);
            case "l":
              return p11624.getInt64Array(v8728);
          }
        }
        const vF1406 = f1406(new Uint8Array(p11624.getArrayBuffer(v8730)));
        const v8731 = new C253(vF1406.buffer);
        switch (v8726) {
          case "b":
          case "c":
            return v8731.getBooleanArray(v8728);
          case "d":
            return v8731.getFloat64Array(v8728);
          case "f":
            return v8731.getFloat32Array(v8728);
          case "i":
            return v8731.getInt32Array(v8728);
          case "l":
            return v8731.getInt64Array(v8728);
        }
        break;
      default:
        throw new Error("THREE.FBXLoader: Unknown property type " + v8726);
    }
  }
}
class C253 {
  constructor(p11625, p11626) {
    this.dv = new DataView(p11625);
    this.offset = 0;
    this.littleEndian = p11626 !== undefined ? p11626 : true;
    this._textDecoder = new TextDecoder();
  }
  getOffset() {
    return this.offset;
  }
  size() {
    return this.dv.buffer.byteLength;
  }
  skip(p11627) {
    this.offset += p11627;
  }
  getBoolean() {
    return (this.getUint8() & 1) === 1;
  }
  getBooleanArray(p11628) {
    const vA467 = [];
    for (let vLN01426 = 0; vLN01426 < p11628; vLN01426++) {
      vA467.push(this.getBoolean());
    }
    return vA467;
  }
  getUint8() {
    const v8732 = this.dv.getUint8(this.offset);
    this.offset += 1;
    return v8732;
  }
  getInt16() {
    const v8733 = this.dv.getInt16(this.offset, this.littleEndian);
    this.offset += 2;
    return v8733;
  }
  getInt32() {
    const v8734 = this.dv.getInt32(this.offset, this.littleEndian);
    this.offset += 4;
    return v8734;
  }
  getInt32Array(p11629) {
    const vA468 = [];
    for (let vLN01427 = 0; vLN01427 < p11629; vLN01427++) {
      vA468.push(this.getInt32());
    }
    return vA468;
  }
  getUint32() {
    const v8735 = this.dv.getUint32(this.offset, this.littleEndian);
    this.offset += 4;
    return v8735;
  }
  getInt64() {
    let v8736;
    let v8737;
    if (this.littleEndian) {
      v8736 = this.getUint32();
      v8737 = this.getUint32();
    } else {
      v8737 = this.getUint32();
      v8736 = this.getUint32();
    }
    if (v8737 & -2147483648) {
      v8737 = ~v8737 & -1;
      v8736 = ~v8736 & -1;
      if (v8736 === 4294967295) {
        v8737 = v8737 + 1 & -1;
      }
      v8736 = v8736 + 1 & -1;
      return -(v8737 * 4294967296 + v8736);
    }
    return v8737 * 4294967296 + v8736;
  }
  getInt64Array(p11630) {
    const vA469 = [];
    for (let vLN01428 = 0; vLN01428 < p11630; vLN01428++) {
      vA469.push(this.getInt64());
    }
    return vA469;
  }
  getUint64() {
    let v8738;
    let v8739;
    if (this.littleEndian) {
      v8738 = this.getUint32();
      v8739 = this.getUint32();
    } else {
      v8739 = this.getUint32();
      v8738 = this.getUint32();
    }
    return v8739 * 4294967296 + v8738;
  }
  getFloat32() {
    const v8740 = this.dv.getFloat32(this.offset, this.littleEndian);
    this.offset += 4;
    return v8740;
  }
  getFloat32Array(p11631) {
    const vA470 = [];
    for (let vLN01429 = 0; vLN01429 < p11631; vLN01429++) {
      vA470.push(this.getFloat32());
    }
    return vA470;
  }
  getFloat64() {
    const v8741 = this.dv.getFloat64(this.offset, this.littleEndian);
    this.offset += 8;
    return v8741;
  }
  getFloat64Array(p11632) {
    const vA471 = [];
    for (let vLN01430 = 0; vLN01430 < p11632; vLN01430++) {
      vA471.push(this.getFloat64());
    }
    return vA471;
  }
  getArrayBuffer(p11633) {
    const v8742 = this.dv.buffer.slice(this.offset, this.offset + p11633);
    this.offset += p11633;
    return v8742;
  }
  getString(p11634) {
    const v8743 = this.offset;
    let v8744 = new Uint8Array(this.dv.buffer, v8743, p11634);
    this.skip(p11634);
    const v8745 = v8744.indexOf(0);
    if (v8745 >= 0) {
      v8744 = new Uint8Array(this.dv.buffer, v8743, v8745);
    }
    return this._textDecoder.decode(v8744);
  }
}
class C254 {
  add(p11635, p11636) {
    this[p11635] = p11636;
  }
}
function f1456(p11637) {
  const vLSKaydaraFBXBinary = "Kaydara FBX Binary  \0";
  return p11637.byteLength >= vLSKaydaraFBXBinary.length && vLSKaydaraFBXBinary === f1465(p11637, 0, vLSKaydaraFBXBinary.length);
}
function f1457(p11638) {
  const vA472 = ["K", "a", "y", "d", "a", "r", "a", "\\", "F", "B", "X", "\\", "B", "i", "n", "a", "r", "y", "\\", "\\"];
  let vLN01431 = 0;
  function f1458(p11639) {
    const v8746 = p11638[p11639 - 1];
    p11638 = p11638.slice(vLN01431 + p11639);
    vLN01431++;
    return v8746;
  }
  for (let vLN01432 = 0; vLN01432 < vA472.length; ++vLN01432) {
    const vF1458 = f1458(1);
    if (vF1458 === vA472[vLN01432]) {
      return false;
    }
  }
  return true;
}
function f1459(p11640) {
  const v8747 = /FBXVersion: (\d+)/;
  const v8748 = p11640.match(v8747);
  if (v8748) {
    const vParseInt27 = parseInt(v8748[1]);
    return vParseInt27;
  }
  throw new Error("THREE.FBXLoader: Cannot find the version number for the file given.");
}
function f1460(p11641) {
  return p11641 / 46186158000;
}
const vA473 = [];
function f1461(p11642, p11643, p11644, p11645) {
  let v8749;
  switch (p11645.mappingType) {
    case "ByPolygonVertex":
      v8749 = p11642;
      break;
    case "ByPolygon":
      v8749 = p11643;
      break;
    case "ByVertice":
      v8749 = p11644;
      break;
    case "AllSame":
      v8749 = p11645.indices[0];
      break;
    default:
      console.warn("THREE.FBXLoader: unknown attribute mapping type " + p11645.mappingType);
  }
  if (p11645.referenceType === "IndexToDirect") {
    v8749 = p11645.indices[v8749];
  }
  const v8750 = v8749 * p11645.dataSize;
  const v8751 = v8750 + p11645.dataSize;
  return f1467(vA473, p11645.buffer, v8750, v8751);
}
const v8752 = new THREE.Euler();
const v8753 = new THREE.Vector3();
function f1462(p11646) {
  const v8754 = new THREE.Matrix4();
  const v8755 = new THREE.Matrix4();
  const v8756 = new THREE.Matrix4();
  const v8757 = new THREE.Matrix4();
  const v8758 = new THREE.Matrix4();
  const v8759 = new THREE.Matrix4();
  const v8760 = new THREE.Matrix4();
  const v8761 = new THREE.Matrix4();
  const v8762 = new THREE.Matrix4();
  const v8763 = new THREE.Matrix4();
  const v8764 = new THREE.Matrix4();
  const v8765 = new THREE.Matrix4();
  const v8766 = p11646.inheritType ? p11646.inheritType : 0;
  if (p11646.translation) {
    v8754.setPosition(v8753.fromArray(p11646.translation));
  }
  if (p11646.preRotation) {
    const v8767 = p11646.preRotation.map(THREE.MathUtils.degToRad);
    v8767.push(p11646.eulerOrder || THREE.Euler.DEFAULT_ORDER);
    v8755.makeRotationFromEuler(v8752.fromArray(v8767));
  }
  if (p11646.rotation) {
    const v8768 = p11646.rotation.map(THREE.MathUtils.degToRad);
    v8768.push(p11646.eulerOrder || THREE.Euler.DEFAULT_ORDER);
    v8756.makeRotationFromEuler(v8752.fromArray(v8768));
  }
  if (p11646.postRotation) {
    const v8769 = p11646.postRotation.map(THREE.MathUtils.degToRad);
    v8769.push(p11646.eulerOrder || THREE.Euler.DEFAULT_ORDER);
    v8757.makeRotationFromEuler(v8752.fromArray(v8769));
    v8757.invert();
  }
  if (p11646.scale) {
    v8758.scale(v8753.fromArray(p11646.scale));
  }
  if (p11646.scalingOffset) {
    v8760.setPosition(v8753.fromArray(p11646.scalingOffset));
  }
  if (p11646.scalingPivot) {
    v8759.setPosition(v8753.fromArray(p11646.scalingPivot));
  }
  if (p11646.rotationOffset) {
    v8761.setPosition(v8753.fromArray(p11646.rotationOffset));
  }
  if (p11646.rotationPivot) {
    v8762.setPosition(v8753.fromArray(p11646.rotationPivot));
  }
  if (p11646.parentMatrixWorld) {
    v8764.copy(p11646.parentMatrix);
    v8763.copy(p11646.parentMatrixWorld);
  }
  const v8770 = v8755.clone().multiply(v8756).multiply(v8757);
  const v8771 = new THREE.Matrix4();
  v8771.extractRotation(v8763);
  const v8772 = new THREE.Matrix4();
  v8772.copyPosition(v8763);
  const v8773 = v8772.clone().invert().multiply(v8763);
  const v8774 = v8771.clone().invert().multiply(v8773);
  const vV8758 = v8758;
  const v8775 = new THREE.Matrix4();
  if (v8766 === 0) {
    v8775.copy(v8771).multiply(v8770).multiply(v8774).multiply(vV8758);
  } else if (v8766 === 1) {
    v8775.copy(v8771).multiply(v8774).multiply(v8770).multiply(vV8758);
  } else {
    const v8776 = new THREE.Matrix4().scale(new THREE.Vector3().setFromMatrixScale(v8764));
    const v8777 = v8776.clone().invert();
    const v8778 = v8774.clone().multiply(v8777);
    v8775.copy(v8771).multiply(v8770).multiply(v8778).multiply(vV8758);
  }
  const v8779 = v8762.clone().invert();
  const v8780 = v8759.clone().invert();
  let v8781 = v8754.clone().multiply(v8761).multiply(v8762).multiply(v8755).multiply(v8756).multiply(v8757).multiply(v8779).multiply(v8760).multiply(v8759).multiply(v8758).multiply(v8780);
  const v8782 = new THREE.Matrix4().copyPosition(v8781);
  const v8783 = v8763.clone().multiply(v8782);
  v8765.copyPosition(v8783);
  v8781 = v8765.clone().multiply(v8775);
  v8781.premultiply(v8763.invert());
  return v8781;
}
function f1463(p11647) {
  p11647 = p11647 || 0;
  const vA474 = ["ZYX", "YZX", "XZY", "ZXY", "YXZ", "XYZ"];
  if (p11647 === 6) {
    console.warn("THREE.FBXLoader: unsupported Euler Order: Spherical XYZ. Animations and rotations may be incorrect.");
    return vA474[0];
  }
  return vA474[p11647];
}
function f1464(p11648) {
  const v8784 = p11648.split(",").map(function (p11649) {
    return parseFloat(p11649);
  });
  return v8784;
}
function f1465(p11650, p11651 = 0, p11652 = p11650.byteLength) {
  return new TextDecoder().decode(new Uint8Array(p11650, p11651, p11652));
}
function f1466(p11653, p11654) {
  for (let vLN01433 = 0, v8785 = p11653.length, v8786 = p11654.length; vLN01433 < v8786; vLN01433++, v8785++) {
    p11653[v8785] = p11654[vLN01433];
  }
}
function f1467(p11655, p11656, p11657, p11658) {
  for (let vP11657 = p11657, vLN01434 = 0; vP11657 < p11658; vP11657++, vLN01434++) {
    p11655[vLN01434] = p11656[vP11657];
  }
  return p11655;
}
function f1468(p11659, p11660, p11661) {
  return p11659.slice(0, p11660).concat(p11661).concat(p11659.slice(p11660));
}